import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File; }
};

export type AcceptPolicyInput = {
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  policyConsents: Array<PolicyConsentInput>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** Account lifecycle status: PROVISIONED (admin-created, unclaimed) or ACTIVE (user has logged in) */
export enum AccountStatus {
  Active = 'ACTIVE',
  Provisioned = 'PROVISIONED'
}

export type Activity = {
  __typename?: 'Activity';
  _id: Scalars['ID']['output'];
  activityType: Scalars['String']['output'];
  activityTypeId?: Maybe<Scalars['String']['output']>;
  calculatedCalories?: Maybe<Scalars['Float']['output']>;
  calculatedDistance?: Maybe<Scalars['Float']['output']>;
  calculatedDuration?: Maybe<Scalars['Float']['output']>;
  calculatedPace?: Maybe<Scalars['Float']['output']>;
  calculatedSpeed?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Whether a health device already captured metrics for this activity's time window */
  deviceTracked: Scalars['Boolean']['output'];
  /** Whether the user explicitly set the deviceTracked value (protects against auto-override) */
  deviceTrackedOverride: Scalars['Boolean']['output'];
  difficultyLevel?: Maybe<DifficultyLevel>;
  distanceFormatted: Scalars['String']['output'];
  durationFormatted: Scalars['String']['output'];
  /** First lock reason that applies, or null when editable */
  editBlockReason?: Maybe<EditBlockReason>;
  /** Number of user-initiated edits applied (hard cap of 3) */
  editCount: Scalars['Int']['output'];
  /** Most recent 3 edit snapshots (forensic) */
  editHistory: Array<ActivityEditHistoryEntry>;
  /** Timestamp of the most recent user edit, if any */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<ActivityEquipment>;
  externalIds?: Maybe<ActivityExternalIds>;
  intensityLevel?: Maybe<IntensityLevel>;
  isActive: Scalars['Boolean']['output'];
  /** True when the activity contributed to a COMPLETED challenge and is permanently locked from edits */
  isEditLocked: Scalars['Boolean']['output'];
  /** Whether the current user may edit this activity right now */
  isEditable: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  location?: Maybe<ActivityLocation>;
  locationName?: Maybe<Scalars['String']['output']>;
  metrics: Array<ActivityMetric>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paceFormatted: Scalars['String']['output'];
  personalBests?: Maybe<ActivityPersonalBests>;
  photos?: Maybe<Array<Scalars['String']['output']>>;
  route?: Maybe<ActivityRoute>;
  source: ActivitySource;
  startTime: Scalars['DateTime']['output'];
  status: ActivityStatus;
  surfaceType?: Maybe<SurfaceType>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  weather?: Maybe<ActivityWeather>;
};

export type ActivityEditHistoryEntry = {
  __typename?: 'ActivityEditHistoryEntry';
  at: Scalars['DateTime']['output'];
  clippedByCap: Scalars['Boolean']['output'];
  newKoins: Scalars['Int']['output'];
  oldActivityType: Scalars['String']['output'];
  oldDistanceKm?: Maybe<Scalars['Float']['output']>;
  oldDurationMin: Scalars['Float']['output'];
  oldIntensity?: Maybe<IntensityLevel>;
  oldKoins: Scalars['Int']['output'];
};

/** Activity environment types */
export enum ActivityEnvironment {
  Indoor = 'INDOOR',
  Mixed = 'MIXED',
  Outdoor = 'OUTDOOR'
}

export type ActivityEquipment = {
  __typename?: 'ActivityEquipment';
  brands?: Maybe<Array<Scalars['String']['output']>>;
  equipment?: Maybe<Array<ActivityEquipmentItem>>;
  notes?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type ActivityEquipmentInput = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  equipment?: InputMaybe<Array<ActivityEquipmentItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  totalCost?: InputMaybe<Scalars['Float']['input']>;
};

export type ActivityEquipmentItem = {
  __typename?: 'ActivityEquipmentItem';
  category: EquipmentCategory;
  items: Array<Scalars['String']['output']>;
};

export type ActivityEquipmentItemInput = {
  category: EquipmentCategory;
  items: Array<Scalars['String']['input']>;
};

export type ActivityExternalIds = {
  __typename?: 'ActivityExternalIds';
  appleHealthId?: Maybe<Scalars['String']['output']>;
  fitbitId?: Maybe<Scalars['String']['output']>;
  garminId?: Maybe<Scalars['String']['output']>;
  googleFitId?: Maybe<Scalars['String']['output']>;
  stravaId?: Maybe<Scalars['String']['output']>;
};

export type ActivityFiltersInput = {
  activityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<ActivitySource>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<ActivityStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ActivityHistoryGroupBy {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ActivityHistoryInput = {
  endDate: Scalars['DateTime']['input'];
  groupBy?: InputMaybe<ActivityHistoryGroupBy>;
  startDate: Scalars['DateTime']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ActivityLocation = {
  __typename?: 'ActivityLocation';
  coordinates: Array<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type ActivityLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type ActivityMetric = {
  __typename?: 'ActivityMetric';
  displayName?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type ActivityMetricInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type ActivityPersonalBests = {
  __typename?: 'ActivityPersonalBests';
  isCaloriesPB?: Maybe<Scalars['Boolean']['output']>;
  isDistancePB?: Maybe<Scalars['Boolean']['output']>;
  isDurationPB?: Maybe<Scalars['Boolean']['output']>;
  isPacePB?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityRoute = {
  __typename?: 'ActivityRoute';
  averageSpeed?: Maybe<Scalars['Float']['output']>;
  coordinates: Array<GpsCoordinate>;
  maxSpeed?: Maybe<Scalars['Float']['output']>;
  totalDistance?: Maybe<Scalars['Float']['output']>;
  totalElevationGain?: Maybe<Scalars['Float']['output']>;
  totalElevationLoss?: Maybe<Scalars['Float']['output']>;
};

export type ActivityRouteInput = {
  averageSpeed?: InputMaybe<Scalars['Float']['input']>;
  coordinates: Array<GpsCoordinateInput>;
  maxSpeed?: InputMaybe<Scalars['Float']['input']>;
  totalDistance?: InputMaybe<Scalars['Float']['input']>;
  totalElevationGain?: InputMaybe<Scalars['Float']['input']>;
  totalElevationLoss?: InputMaybe<Scalars['Float']['input']>;
};

/** Fields available for sorting activities */
export enum ActivitySortField {
  Calories = 'CALORIES',
  CreatedAt = 'CREATED_AT',
  Distance = 'DISTANCE',
  Duration = 'DURATION',
  Name = 'NAME',
  StartTime = 'START_TIME'
}

export type ActivitySortInput = {
  field?: InputMaybe<ActivitySortField>;
  order?: InputMaybe<SortOrder>;
};

/** Source of the activity data */
export enum ActivitySource {
  ApiImport = 'API_IMPORT',
  AppleHealth = 'APPLE_HEALTH',
  CsvImport = 'CSV_IMPORT',
  Fitbit = 'FITBIT',
  Garmin = 'GARMIN',
  GoogleFit = 'GOOGLE_FIT',
  Manual = 'MANUAL',
  Polar = 'POLAR',
  Strava = 'STRAVA',
  Suunto = 'SUUNTO',
  Wahoo = 'WAHOO'
}

export type ActivityStats = {
  __typename?: 'ActivityStats';
  activityTypeBreakdown: Array<ActivityTypeBreakdown>;
  averageCalories: Scalars['Float']['output'];
  averageDistance: Scalars['Float']['output'];
  averageDuration: Scalars['Float']['output'];
  averagePace: Scalars['Float']['output'];
  bestDistance: Scalars['Float']['output'];
  bestDuration: Scalars['Float']['output'];
  bestPace: Scalars['Float']['output'];
  timeSeries?: Maybe<Array<TimeSeriesDataPoint>>;
  totalActivities: Scalars['Int']['output'];
  totalCalories: Scalars['Float']['output'];
  totalDistance: Scalars['Float']['output'];
  totalDuration: Scalars['Float']['output'];
  totalSteps: Scalars['Int']['output'];
};

/** Current status of the activity */
export enum ActivityStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Paused = 'PAUSED'
}

export type ActivityType = {
  __typename?: 'ActivityType';
  _id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  constraints?: Maybe<ActivityTypeConstraints>;
  conversionRules?: Maybe<Array<ConversionRule>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultCaloriesPerHour?: Maybe<Scalars['Float']['output']>;
  defaultIntensity?: Maybe<IntensityLevel>;
  defaultMETValue?: Maybe<Scalars['Float']['output']>;
  defaultStepCadence?: Maybe<Scalars['Float']['output']>;
  defaultSurfaces?: Maybe<Array<SurfaceType>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isBuiltIn: Scalars['Boolean']['output'];
  isCustom: Scalars['Boolean']['output'];
  metricFields: Array<MetricField>;
  name: Scalars['String']['output'];
  overlapEligibility?: Maybe<OverlapEligibility>;
  primaryEnvironment?: Maybe<ActivityEnvironment>;
  recommendedDifficulty?: Maybe<DifficultyLevel>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ActivityTypeBreakdown = {
  __typename?: 'ActivityTypeBreakdown';
  count: Scalars['Int']['output'];
  totalCalories: Scalars['Float']['output'];
  totalDistance: Scalars['Float']['output'];
  totalDuration: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type ActivityTypeConstraints = {
  __typename?: 'ActivityTypeConstraints';
  allowedSurfaces?: Maybe<Array<SurfaceType>>;
  allowedWeatherConditions?: Maybe<Array<WeatherCondition>>;
  environment?: Maybe<ActivityEnvironment>;
  hasSeasonalRestrictions?: Maybe<Scalars['Boolean']['output']>;
  idealSeasons?: Maybe<Array<Scalars['Int']['output']>>;
  maximumDifficulty?: Maybe<DifficultyLevel>;
  minimumDifficulty?: Maybe<DifficultyLevel>;
  recommendedEquipment?: Maybe<Array<EquipmentCategory>>;
  requiredEquipment?: Maybe<Array<EquipmentCategory>>;
  requiresSupervision?: Maybe<Scalars['Boolean']['output']>;
  typicalIntensityLevels?: Maybe<Array<IntensityLevel>>;
};

export type ActivityTypeCount = {
  __typename?: 'ActivityTypeCount';
  activityType: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type ActivityTypeFiltersInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBuiltIn?: InputMaybe<Scalars['Boolean']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Fields available for sorting activity types */
export enum ActivityTypeSortField {
  Category = 'CATEGORY',
  CreatedAt = 'CREATED_AT',
  DisplayName = 'DISPLAY_NAME',
  Name = 'NAME'
}

export type ActivityTypeSortInput = {
  field?: InputMaybe<ActivityTypeSortField>;
  order?: InputMaybe<SortOrder>;
};

export type ActivityWeather = {
  __typename?: 'ActivityWeather';
  conditions?: Maybe<WeatherCondition>;
  humidity?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  uvIndex?: Maybe<Scalars['Float']['output']>;
  visibility?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
};

export type ActivityWeatherInput = {
  conditions?: InputMaybe<WeatherCondition>;
  humidity?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  uvIndex?: InputMaybe<Scalars['Float']['input']>;
  visibility?: InputMaybe<Scalars['Float']['input']>;
  windSpeed?: InputMaybe<Scalars['Float']['input']>;
};

/** Add interaction to lead timeline */
export type AddLeadInteractionInput = {
  content: Scalars['String']['input'];
  leadId: Scalars['ID']['input'];
  type: InteractionType;
};

export type AdjustKoinsInput = {
  amount: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  /** Required (2026-05-18): admin-supplied unique reference for the adjustment (ticket ID, incident ID, batch ID). Prevents silent dedup of legitimate repeat adjustments. */
  referenceId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Input for ADMIN creating an organization with initial ORG_ADMIN assignment */
export type AdminCreateOrganizationInput = {
  adminDepartment: Scalars['String']['input'];
  adminEmail: Scalars['String']['input'];
  adminFirstName: Scalars['String']['input'];
  adminJobTitle?: InputMaybe<Scalars['String']['input']>;
  adminLastName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Pricing tier (only for COMMERCIAL orgs) */
  tier?: InputMaybe<OrganizationTier>;
  type: OrganizationType;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Result of ADMIN creating an organization with initial ORG_ADMIN */
export type AdminCreateOrganizationResult = {
  __typename?: 'AdminCreateOrganizationResult';
  assignedAdmin: User;
  isNewUser: Scalars['Boolean']['output'];
  organization: Organization;
};

/** User search result row for admin panel */
export type AdminSearchUserRow = {
  __typename?: 'AdminSearchUserRow';
  _id: Scalars['ID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  koinBalance: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  lifetimeKoins: Scalars['Int']['output'];
  organizationNames: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  tier: Scalars['String']['output'];
};

/** Paginated admin user search results */
export type AdminSearchUsersResult = {
  __typename?: 'AdminSearchUsersResult';
  totalCount: Scalars['Int']['output'];
  users: Array<AdminSearchUserRow>;
};

/** Full user profile for admin support panel */
export type AdminUserDetail = {
  __typename?: 'AdminUserDetail';
  accountStatus: Scalars['String']['output'];
  organizations: Array<AdminUserOrganization>;
  totalLedgerEntries: Scalars['Int']['output'];
  user: User;
};

/** Paginated ledger entries for admin audit view */
export type AdminUserLedgerPage = {
  __typename?: 'AdminUserLedgerPage';
  edges: Array<KoinsLedgerEntry>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Organization membership summary for admin user detail */
export type AdminUserOrganization = {
  __typename?: 'AdminUserOrganization';
  isActive: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

/** Admin filter options for all orders */
export type AllOrdersFilterInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketplaceItemId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrderStatus>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters for allOrganizations ADMIN query */
export type AllOrganizationsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<OrganizationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<OrganizationStatus>;
  /** Filter by tier(s) */
  tiers?: InputMaybe<Array<OrganizationTier>>;
  types?: InputMaybe<Array<OrganizationType>>;
};

/** Paginated list of all organizations for ADMIN */
export type AllOrganizationsResult = {
  __typename?: 'AllOrganizationsResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Organization>;
  total: Scalars['Int']['output'];
};

/** Dimension to break an analytics event down by */
export enum AnalyticsBreakdownDimension {
  AppVersion = 'APP_VERSION',
  DimValue = 'DIM_VALUE',
  Locale = 'LOCALE',
  Platform = 'PLATFORM'
}

/** One value of a dimension breakdown for an event */
export type AnalyticsBreakdownPoint = {
  __typename?: 'AnalyticsBreakdownPoint';
  _suppressed?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
};

/** Inclusive UTC date range (YYYY-MM-DD) for analytics queries */
export type AnalyticsDateRangeInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type AnalyticsEventInput = {
  /** Occurrences in this batch (server clamps to 1–1000; default 1). */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Single event-specific dimension (policyKey | pushType | step). Ignored for events that have no dimension. */
  dimValue?: InputMaybe<Scalars['String']['input']>;
  /** Event name. Unknown names are dropped server-side (counted in `dropped`) rather than rejecting the whole batch — see ANALYTICS_EVENTS for the canonical list. */
  event: Scalars['String']['input'];
  /** Client-claimed ISO-8601 UTC timestamp; server clamps to [today-1, today]. */
  occurredAt?: InputMaybe<Scalars['String']['input']>;
};

/** Time-bucket granularity for analytics time-series (daily counters rolled up) */
export enum AnalyticsGranularity {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** One time bucket of an analytics event series */
export type AnalyticsTimeSeriesPoint = {
  __typename?: 'AnalyticsTimeSeriesPoint';
  _suppressed?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  period: Scalars['String']['output'];
  periodEnd: Scalars['String']['output'];
};

/** One event in the top-events ranking */
export type AnalyticsTopEventPoint = {
  __typename?: 'AnalyticsTopEventPoint';
  _suppressed?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  event: Scalars['String']['output'];
};

/** Assign lead to an admin user */
export type AssignLeadInput = {
  assigneeId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};

export enum AuthMethod {
  Both = 'BOTH',
  MagicLink = 'MAGIC_LINK',
  Password = 'PASSWORD',
  Sso = 'SSO'
}

export type AuthPayload = {
  __typename?: 'AuthPayload';
  /** Long-lived JWT scoped to syncHealthTelemetry. Used by the native HealthKit background sync module (270-day TTL). */
  backgroundSyncToken?: Maybe<Scalars['String']['output']>;
  expiresIn: Scalars['String']['output'];
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  needsPolicyAcceptance?: Maybe<Scalars['Boolean']['output']>;
  /** Opaque refresh token for silent token renewal. Null when only the access token is refreshed (e.g. acceptPolicy). */
  refreshToken?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  user: User;
};

/** Provider of bonus rewards */
export enum BonusProvider {
  Organization = 'ORGANIZATION',
  System = 'SYSTEM'
}

/** Type of bonus claim */
export enum BonusType {
  FirstPrize = 'FIRST_PRIZE',
  Onboarding = 'ONBOARDING',
  Organization = 'ORGANIZATION'
}

/** Available broadcast channel information */
export type BroadcastChannelType = {
  __typename?: 'BroadcastChannelType';
  id: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Bulk import behavior for existing rows */
export enum BulkImportMode {
  AddOnly = 'ADD_ONLY',
  Upsert = 'UPSERT'
}

export type BulkImportRowError = {
  __typename?: 'BulkImportRowError';
  error: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type BulkImportUsersInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  enrollExistingUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<BulkImportMode>;
  updateExistingMembers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkImportUsersReport = {
  __typename?: 'BulkImportUsersReport';
  errorCount: Scalars['Int']['output'];
  errors: Array<BulkImportRowError>;
  skippedCount: Scalars['Int']['output'];
  skippedRows: Array<Scalars['Int']['output']>;
  successCount: Scalars['Int']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type CancellationResult = {
  __typename?: 'CancellationResult';
  success: Scalars['Boolean']['output'];
};

export type CategoryCount = {
  __typename?: 'CategoryCount';
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  /** Total Koins spent on items in this category during the period. */
  koinsSpent: Scalars['Float']['output'];
};

export type Challenge = {
  __typename?: 'Challenge';
  _id: Scalars['ID']['output'];
  accessibility: ChallengeAccessibility;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorId: Scalars['ID']['output'];
  daysRemaining: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  entryFee: Scalars['Int']['output'];
  inviteCodes?: Maybe<Array<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  isEnded: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isStarted: Scalars['Boolean']['output'];
  metric: ChallengeMetric;
  name: Scalars['String']['output'];
  nextOccurrenceDate?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  participantCount: Scalars['Int']['output'];
  participants: Array<ChallengeParticipant>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  prizePool: Scalars['Int']['output'];
  recurrence?: Maybe<RecurrenceConfigType>;
  rewards?: Maybe<Array<ChallengeReward>>;
  sourceTemplateId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: ChallengeStatus;
  targetValue?: Maybe<Scalars['Float']['output']>;
  type: ChallengeType;
  updatedAt: Scalars['DateTime']['output'];
  viewerParticipationStatus: ChallengeViewerParticipationStatus;
};


export type ChallengeParticipantsArgs = {
  input?: InputMaybe<ChallengeParticipantsInput>;
};

/** Who can access and join the challenge */
export enum ChallengeAccessibility {
  InviteOnly = 'INVITE_ONLY',
  OrgOnly = 'ORG_ONLY',
  Public = 'PUBLIC'
}

export type ChallengeConnection = {
  __typename?: 'ChallengeConnection';
  edges: Array<ChallengeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChallengeEdge = {
  __typename?: 'ChallengeEdge';
  cursor: Scalars['String']['output'];
  node: ChallengeSummary;
};

/** Public-facing challenge entry fee limits. Available to any authenticated user. */
export type ChallengeEntryFeeLimitsType = {
  __typename?: 'ChallengeEntryFeeLimitsType';
  maxBuyIn: Scalars['Int']['output'];
  minBuyIn: Scalars['Int']['output'];
  minParticipantsForPaid: Scalars['Int']['output'];
};

export type ChallengeFiltersInput = {
  accessibilities?: InputMaybe<Array<ChallengeAccessibility>>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  metrics?: InputMaybe<Array<ChallengeMetric>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ListingScope>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<ChallengeStatus>>;
  types?: InputMaybe<Array<ChallengeType>>;
};

/** Metric to compete on in challenges */
export enum ChallengeMetric {
  Calories = 'CALORIES',
  Distance = 'DISTANCE',
  Duration = 'DURATION',
  Steps = 'STEPS'
}

export type ChallengeParticipant = {
  __typename?: 'ChallengeParticipant';
  _id: Scalars['ID']['output'];
  activityIds: Array<Scalars['String']['output']>;
  challengeId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentValue: Scalars['Float']['output'];
  hasPaidEntry: Scalars['Boolean']['output'];
  hasReachedTarget: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  position: Scalars['Int']['output'];
  targetReachedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

/** Fields available for sorting challenge participants */
export enum ChallengeParticipantSortField {
  CurrentValue = 'CURRENT_VALUE',
  JoinedAt = 'JOINED_AT',
  Position = 'POSITION',
  TargetReachedAt = 'TARGET_REACHED_AT',
  UserName = 'USER_NAME'
}

export type ChallengeParticipantSortInput = {
  field?: InputMaybe<ChallengeParticipantSortField>;
  order?: InputMaybe<SortOrder>;
};

export type ChallengeParticipantsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ChallengeParticipantSortInput>;
};

export type ChallengeReward = {
  __typename?: 'ChallengeReward';
  description: Scalars['String']['output'];
  fromRank: Scalars['Int']['output'];
  /** @deprecated Legacy field. Use fromRank/toRank instead. Will be removed in a future release. */
  position: Scalars['String']['output'];
  toRank: Scalars['Int']['output'];
};

export type ChallengeRewardInput = {
  description: Scalars['String']['input'];
  fromRank: Scalars['Int']['input'];
  toRank: Scalars['Int']['input'];
};

/** Fields available for sorting challenges */
export enum ChallengeSortField {
  CreatedAt = 'CREATED_AT',
  EndDate = 'END_DATE',
  Name = 'NAME',
  ParticipantCount = 'PARTICIPANT_COUNT',
  StartDate = 'START_DATE'
}

export type ChallengeSortInput = {
  field?: InputMaybe<ChallengeSortField>;
  order?: InputMaybe<SortOrder>;
};

/** Current status of the challenge */
export enum ChallengeStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Upcoming = 'UPCOMING'
}

export type ChallengeSummary = {
  __typename?: 'ChallengeSummary';
  _id: Scalars['ID']['output'];
  accessibility: ChallengeAccessibility;
  creator?: Maybe<User>;
  creatorId: Scalars['ID']['output'];
  daysRemaining: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  entryFee?: Maybe<Scalars['Int']['output']>;
  isEnded: Scalars['Boolean']['output'];
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  isStarted: Scalars['Boolean']['output'];
  metric: ChallengeMetric;
  name: Scalars['String']['output'];
  nextOccurrenceDate?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  participantCount: Scalars['Int']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<RecurrenceConfigType>;
  sourceTemplateId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: ChallengeStatus;
  targetValue?: Maybe<Scalars['Float']['output']>;
  type: ChallengeType;
  viewerParticipationStatus: ChallengeViewerParticipationStatus;
};

/** Type of challenge competition */
export enum ChallengeType {
  BestYouCan = 'BEST_YOU_CAN',
  HitTheTarget = 'HIT_THE_TARGET'
}

/** Current viewer participation status for a challenge */
export enum ChallengeViewerParticipationStatus {
  Joined = 'JOINED',
  NotJoined = 'NOT_JOINED'
}

/** Current status of a chat integration connection */
export enum ChatIntegrationStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Error = 'ERROR',
  PendingApproval = 'PENDING_APPROVAL',
  Revoked = 'REVOKED'
}

/** Chat integration connection for an organization */
export type ChatIntegrationType = {
  __typename?: 'ChatIntegrationType';
  _id: Scalars['ID']['output'];
  challengeAnnouncementsEnabled: Scalars['Boolean']['output'];
  channelId?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disconnectedAt?: Maybe<Scalars['DateTime']['output']>;
  eventAnnouncementsEnabled: Scalars['Boolean']['output'];
  installedAt?: Maybe<Scalars['DateTime']['output']>;
  installedBy?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastBroadcastAt?: Maybe<Scalars['DateTime']['output']>;
  lastBroadcastType?: Maybe<Scalars['String']['output']>;
  leaderboardDropsEnabled: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  provider: ChatProviderType;
  rewardShoutoutsEnabled: Scalars['Boolean']['output'];
  status: ChatIntegrationStatus;
  totalBroadcasts: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

/** Supported chat platform providers */
export enum ChatProviderType {
  GoogleChat = 'GOOGLE_CHAT',
  MsTeams = 'MS_TEAMS',
  Slack = 'SLACK'
}

export type ClaimBonusInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  type: BonusType;
};

export type ClaimBonusResult = {
  __typename?: 'ClaimBonusResult';
  amount: Scalars['Int']['output'];
  awarded: Scalars['Boolean']['output'];
  koinBalance: Scalars['Int']['output'];
  ledgerEntry?: Maybe<KoinsLedgerEntry>;
  lifetimeKoins: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  provider: BonusProvider;
  type: BonusType;
};

/** Company employee count range */
export enum CompanySize {
  Lg = 'LG',
  Md = 'MD',
  Sm = 'SM',
  Xl = 'XL',
  Xs = 'XS'
}

export type ConnectDeviceInput = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  provider: HealthProvider;
};

export type ConversionCoefficients = {
  __typename?: 'ConversionCoefficients';
  a?: Maybe<Scalars['Float']['output']>;
  b?: Maybe<Scalars['Float']['output']>;
  c?: Maybe<Scalars['Float']['output']>;
};

export type ConversionCoefficientsInput = {
  a?: InputMaybe<Scalars['Float']['input']>;
  b?: InputMaybe<Scalars['Float']['input']>;
  c?: InputMaybe<Scalars['Float']['input']>;
};

/** Formula type for converting metrics to distance/calories */
export enum ConversionFormula {
  Custom = 'CUSTOM',
  Exponential = 'EXPONENTIAL',
  Linear = 'LINEAR',
  Logarithmic = 'LOGARITHMIC',
  Polynomial = 'POLYNOMIAL'
}

export type ConversionRule = {
  __typename?: 'ConversionRule';
  coefficients?: Maybe<ConversionCoefficients>;
  customFormula?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  formula: ConversionFormula;
  sourceMetrics: Array<Scalars['String']['output']>;
  targetMetric: Scalars['String']['output'];
};

export type ConversionRuleInput = {
  coefficients?: InputMaybe<ConversionCoefficientsInput>;
  customFormula?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formula: ConversionFormula;
  sourceMetrics: Array<Scalars['String']['input']>;
  targetMetric: Scalars['String']['input'];
};

/** Input for converting a lead to an organization */
export type ConvertLeadInput = {
  adminDepartment: Scalars['String']['input'];
  adminFirstName: Scalars['String']['input'];
  adminJobTitle?: InputMaybe<Scalars['String']['input']>;
  adminLastName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  leadId: Scalars['ID']['input'];
  organizationTier?: InputMaybe<OrganizationTier>;
  organizationType: OrganizationType;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Result of converting a lead to an organization */
export type ConvertLeadResultType = {
  __typename?: 'ConvertLeadResultType';
  isNewUser: Scalars['Boolean']['output'];
  lead: LeadType;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
};

export type CreateActivityInput = {
  activityType: Scalars['String']['input'];
  activityTypeId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** User asserts device already tracked this activity */
  deviceTracked?: InputMaybe<Scalars['Boolean']['input']>;
  difficultyLevel?: InputMaybe<DifficultyLevel>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipment?: InputMaybe<ActivityEquipmentInput>;
  intensityLevel?: InputMaybe<IntensityLevel>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<ActivityLocationInput>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  metrics: Array<ActivityMetricInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<ActivityRouteInput>;
  source?: InputMaybe<ActivitySource>;
  startTime: Scalars['DateTime']['input'];
  status?: InputMaybe<ActivityStatus>;
  surfaceType?: InputMaybe<SurfaceType>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  weather?: InputMaybe<ActivityWeatherInput>;
};

export type CreateActivityTypeInput = {
  category: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  conversionRules?: InputMaybe<Array<ConversionRuleInput>>;
  defaultCaloriesPerHour?: InputMaybe<Scalars['Float']['input']>;
  defaultMETValue?: InputMaybe<Scalars['Float']['input']>;
  defaultStepCadence?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  metricFields: Array<MetricFieldInput>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateChallengeInput = {
  accessibility?: InputMaybe<ChallengeAccessibility>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  entryFee?: InputMaybe<Scalars['Int']['input']>;
  metric: ChallengeMetric;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<RecurrenceConfigInput>;
  rewards?: InputMaybe<Array<ChallengeRewardInput>>;
  startDate: Scalars['DateTime']['input'];
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  type: ChallengeType;
};

export type CreateEventInput = {
  accessibility?: InputMaybe<EventAccessibility>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  endTime?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<EventLocationInput>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<RecurrenceConfigInput>;
  startDate: Scalars['DateTime']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInviteOptionsInput = {
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
};

/** Create a new lead manually */
export type CreateLeadInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  size: CompanySize;
  source?: InputMaybe<LeadSource>;
  tier: LeadTier;
};

/** Input for creating a new marketplace item */
export type CreateMarketplaceItemInput = {
  /** Enable monthly auto-refill */
  autoRefill?: InputMaybe<Scalars['Boolean']['input']>;
  category: MarketplaceCategory;
  description: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentInstructions?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  koinsPrice: Scalars['Int']['input'];
  /** Extensible JSON metadata as string */
  metadata?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Day of month (1-28) to refill */
  refillDay?: InputMaybe<Scalars['Int']['input']>;
  /** Quantity to restock monthly */
  refillQuantity?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<MarketplaceScope>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** null or omit for unlimited stock */
  totalInventory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrganizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  type: OrganizationType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type DailyActivitySummary = {
  __typename?: 'DailyActivitySummary';
  activities: Array<Activity>;
  activityCount: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  totalCalories: Scalars['Float']['output'];
  totalDistance: Scalars['Float']['output'];
  totalSteps: Scalars['Int']['output'];
};

/** Single day aggregate for chart data */
export type DailyBreakdown = {
  __typename?: 'DailyBreakdown';
  _suppressed?: Maybe<Scalars['Boolean']['output']>;
  activeMembers: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  koinsEarned: Scalars['Int']['output'];
  koinsSpent: Scalars['Int']['output'];
  totalMembers: Scalars['Int']['output'];
  totalSteps: Scalars['Int']['output'];
};

/** Time period for dashboard aggregation */
export enum DashboardPeriod {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK'
}

/** Trend percentages vs previous period */
export type DashboardTrend = {
  __typename?: 'DashboardTrend';
  activeMembersTrend: Scalars['Float']['output'];
  koinsEarnedTrend: Scalars['Float']['output'];
  koinsSpentTrend: Scalars['Float']['output'];
  stepsTrend: Scalars['Float']['output'];
};

export type DeletionRequestResult = {
  __typename?: 'DeletionRequestResult';
  message: Scalars['String']['output'];
  scheduledFor: Scalars['DateTime']['output'];
};

/** Difficulty levels for activities */
export enum DifficultyLevel {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Expert = 'EXPERT',
  Intermediate = 'INTERMEDIATE'
}

export type DurationTierType = {
  __typename?: 'DurationTierType';
  fromMinutes: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  toMinutes: Scalars['Int']['output'];
};

export type EconomyConfigType = {
  __typename?: 'EconomyConfigType';
  _id: Scalars['ID']['output'];
  activityCooldownMinutes: Scalars['Int']['output'];
  anomalyRollingMultiplier: Scalars['Float']['output'];
  challengeHouseBurnPercentage: Scalars['Float']['output'];
  challengeMaxBuyIn: Scalars['Int']['output'];
  challengeMinBuyIn: Scalars['Int']['output'];
  challengeMinParticipantsForPaid: Scalars['Int']['output'];
  challengePrizeDistribution: Array<PrizeDistributionType>;
  challengePrizePoolPercentage: Scalars['Float']['output'];
  challengeTwoPlayerWinnerPct: Scalars['Float']['output'];
  dailyExerciseKoinsCap: Scalars['Int']['output'];
  dailyStepKoinsCap: Scalars['Int']['output'];
  durationTiers: Array<DurationTierType>;
  exerciseScaleFactor: Scalars['Float']['output'];
  fairnessAgeBaseline: Scalars['Int']['output'];
  fairnessAgeCoefficient: Scalars['Float']['output'];
  fairnessBMIBaseline: Scalars['Int']['output'];
  fairnessBMICoefficient: Scalars['Float']['output'];
  fairnessMaxMultiplier: Scalars['Float']['output'];
  fallbackMETValue: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  manualSourcePenalty: Scalars['Float']['output'];
  maxManualCaloriesPerActivity: Scalars['Int']['output'];
  maxManualDistanceKmPerActivity: Scalars['Int']['output'];
  maxManualStepsPerActivity: Scalars['Int']['output'];
  maxStepsPerMinute: Scalars['Int']['output'];
  onboardingBonusAmount: Scalars['Int']['output'];
  referencePricePerTenEuro: Scalars['Int']['output'];
  stepTiers: Array<StepTierType>;
  streakMinActivityMinutesForQualifyingDay: Scalars['Int']['output'];
  streakMinStepsForQualifyingDay: Scalars['Int']['output'];
  streakRequiredDays: Scalars['Int']['output'];
  streakRewardKoins: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type EditActivityInput = {
  activityId: Scalars['ID']['input'];
  activityType?: InputMaybe<Scalars['String']['input']>;
  activityTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Editable distance, in kilometres */
  distanceKm?: InputMaybe<Scalars['Float']['input']>;
  /** Editable duration, in minutes */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  intensity?: InputMaybe<IntensityLevel>;
};

export type EditActivityPreview = {
  __typename?: 'EditActivityPreview';
  /** Why canSave is false, if applicable */
  blockReason?: Maybe<EditBlockReason>;
  /** False when the user must not be allowed to commit this edit */
  canSave: Scalars['Boolean']['output'];
  /** True when the daily exercise cap is clipping the delta */
  capApplied: Scalars['Boolean']['output'];
  /** User's current koinBalance */
  currentBalance: Scalars['Int']['output'];
  /** newKoins minus oldKoins (after daily cap) */
  delta: Scalars['Int']['output'];
  /** Koins this activity would earn under the proposed edit (after daily cap) */
  newKoins: Scalars['Int']['output'];
  /** Koins this activity currently earns */
  oldKoins: Scalars['Int']['output'];
};

export type EditActivityResult = {
  __typename?: 'EditActivityResult';
  activity: Activity;
  /** Challenge IDs whose leaderboards were enqueued for recalculation */
  affectedChallengeIds: Array<Scalars['ID']['output']>;
  /** True when the daily exercise cap clipped the candidate delta */
  capApplied: Scalars['Boolean']['output'];
  /** Net Koin delta applied (after daily-cap clipping). Positive = earned more, negative = reversed. */
  koinDelta: Scalars['Int']['output'];
  /** User's koinBalance after applying the delta */
  newBalance: Scalars['Int']['output'];
};

/** Why a manual activity cannot be edited right now */
export enum EditBlockReason {
  ActivityEditLimitReached = 'ACTIVITY_EDIT_LIMIT_REACHED',
  ActivityLockedChallengeCompleted = 'ACTIVITY_LOCKED_CHALLENGE_COMPLETED',
  ActivityLockedDeviceTracked = 'ACTIVITY_LOCKED_DEVICE_TRACKED',
  ActivityLockedTimeExpired = 'ACTIVITY_LOCKED_TIME_EXPIRED',
  ActivityNotManual = 'ACTIVITY_NOT_MANUAL',
  ActivityValuesInvalid = 'ACTIVITY_VALUES_INVALID',
  DailyCapExceeded = 'DAILY_CAP_EXCEEDED',
  InsufficientBalance = 'INSUFFICIENT_BALANCE'
}

/** Result of enrolling pending roster users after a tier upgrade */
export type EnrollPendingResult = {
  __typename?: 'EnrollPendingResult';
  enrolledCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
};

/** Equipment categories */
export enum EquipmentCategory {
  Accessories = 'ACCESSORIES',
  Bike = 'BIKE',
  Clothing = 'CLOTHING',
  Footwear = 'FOOTWEAR',
  Nutrition = 'NUTRITION',
  SafetyGear = 'SAFETY_GEAR',
  Technology = 'TECHNOLOGY',
  Tools = 'TOOLS'
}

export type Event = {
  __typename?: 'Event';
  _id: Scalars['ID']['output'];
  accessibility: EventAccessibility;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorId: Scalars['ID']['output'];
  daysUntilStart: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['String']['output']>;
  inviteCodes?: Maybe<Array<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  isEnded: Scalars['Boolean']['output'];
  isStarted: Scalars['Boolean']['output'];
  location?: Maybe<EventLocation>;
  name: Scalars['String']['output'];
  nextOccurrenceDate?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  participantCount: Scalars['Int']['output'];
  participants: Array<EventParticipant>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<RecurrenceConfigType>;
  sourceTemplateId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  status: EventStatus;
  updatedAt: Scalars['DateTime']['output'];
  viewerParticipationStatus: EventViewerParticipationStatus;
};


export type EventParticipantsArgs = {
  input?: InputMaybe<EventParticipantsInput>;
};

/** Who can access and join the event */
export enum EventAccessibility {
  InviteOnly = 'INVITE_ONLY',
  OrgOnly = 'ORG_ONLY',
  Public = 'PUBLIC'
}

export type EventConnection = {
  __typename?: 'EventConnection';
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String']['output'];
  node: EventSummary;
};

export type EventFiltersInput = {
  accessibilities?: InputMaybe<Array<EventAccessibility>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ListingScope>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<EventStatus>>;
};

export type EventLocation = {
  __typename?: 'EventLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  isVirtual: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  meetingLink?: Maybe<Scalars['String']['output']>;
};

export type EventLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
};

export type EventParticipant = {
  __typename?: 'EventParticipant';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: EventParticipantStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

/** Fields available for sorting event participants */
export enum EventParticipantSortField {
  JoinedAt = 'JOINED_AT',
  Status = 'STATUS',
  UserName = 'USER_NAME'
}

export type EventParticipantSortInput = {
  field?: InputMaybe<EventParticipantSortField>;
  order?: InputMaybe<SortOrder>;
};

/** Participant's status for the event */
export enum EventParticipantStatus {
  Going = 'GOING',
  Maybe = 'MAYBE',
  NotGoing = 'NOT_GOING'
}

export type EventParticipantsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EventParticipantSortInput>;
  statuses?: InputMaybe<Array<EventParticipantStatus>>;
};

/** Fields available for sorting events */
export enum EventSortField {
  CreatedAt = 'CREATED_AT',
  EndDate = 'END_DATE',
  Name = 'NAME',
  ParticipantCount = 'PARTICIPANT_COUNT',
  StartDate = 'START_DATE'
}

export type EventSortInput = {
  field?: InputMaybe<EventSortField>;
  order?: InputMaybe<SortOrder>;
};

/** Current status of the event */
export enum EventStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Upcoming = 'UPCOMING'
}

export type EventSummary = {
  __typename?: 'EventSummary';
  _id: Scalars['ID']['output'];
  accessibility: EventAccessibility;
  creator?: Maybe<User>;
  creatorId: Scalars['ID']['output'];
  daysUntilStart: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['String']['output']>;
  isEnded: Scalars['Boolean']['output'];
  isStarted: Scalars['Boolean']['output'];
  location?: Maybe<EventLocation>;
  name: Scalars['String']['output'];
  nextOccurrenceDate?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  participantCount: Scalars['Int']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<RecurrenceConfigType>;
  sourceTemplateId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  status: EventStatus;
  viewerParticipationStatus: EventViewerParticipationStatus;
};

/** Current viewer participation status for an event */
export enum EventViewerParticipationStatus {
  Declined = 'DECLINED',
  Going = 'GOING',
  Maybe = 'MAYBE',
  NotParticipating = 'NOT_PARTICIPATING'
}

/** Action intent for feed item CTA */
export enum FeedActionIntent {
  JoinChallenge = 'JOIN_CHALLENGE',
  JoinEvent = 'JOIN_EVENT',
  ViewChallengeRewards = 'VIEW_CHALLENGE_REWARDS',
  ViewEvent = 'VIEW_EVENT',
  ViewProfile = 'VIEW_PROFILE'
}

/** Visual state for feed item CTA */
export enum FeedActionState {
  Active = 'ACTIVE',
  Default = 'DEFAULT',
  Ended = 'ENDED',
  Full = 'FULL'
}

export type FeedFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<FeedScope>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<FeedItemType>>;
};

export type FeedItem = {
  __typename?: 'FeedItem';
  actionDisabled: Scalars['Boolean']['output'];
  actionIntent: FeedActionIntent;
  actionLabel?: Maybe<Scalars['String']['output']>;
  actionState: FeedActionState;
  actorDisplayName: Scalars['String']['output'];
  actorIsCurrentUser: Scalars['Boolean']['output'];
  /** Profile picture URL of the actor (user avatar) */
  actorProfilePicture?: Maybe<Scalars['String']['output']>;
  entryFee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Photo URL for the related challenge or event */
  imageUrl?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  relatedId: Scalars['ID']['output'];
  relatedType: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  targetName?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: FeedItemType;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Type of feed item */
export enum FeedItemType {
  ChallengeCompleted = 'CHALLENGE_COMPLETED',
  ChallengeCreated = 'CHALLENGE_CREATED',
  EventCreated = 'EVENT_CREATED',
  NewMember = 'NEW_MEMBER'
}

/** Scope of feed items: organization-only or organization + public */
export enum FeedScope {
  Global = 'GLOBAL',
  Organization = 'ORGANIZATION'
}

export type Feedback = {
  __typename?: 'Feedback';
  _id: Scalars['ID']['output'];
  allowFollowUp: Scalars['Boolean']['output'];
  category: FeedbackCategory;
  createdAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  status: FeedbackStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export enum FeedbackCategory {
  Bug = 'BUG',
  Complaint = 'COMPLAINT',
  FeatureRequest = 'FEATURE_REQUEST',
  General = 'GENERAL',
  Praise = 'PRAISE'
}

export type FeedbackFiltersInput = {
  categories?: InputMaybe<Array<FeedbackCategory>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  statuses?: InputMaybe<Array<FeedbackStatus>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type FeedbackInput = {
  allowFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  category: FeedbackCategory;
  message: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type FeedbackResponse = {
  __typename?: 'FeedbackResponse';
  feedbackId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum FeedbackSortField {
  Category = 'CATEGORY',
  CreatedAt = 'CREATED_AT',
  Rating = 'RATING',
  Status = 'STATUS'
}

export type FeedbackSortInput = {
  field: FeedbackSortField;
  order: SortOrder;
};

export enum FeedbackStatus {
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Reviewed = 'REVIEWED'
}

/** How the reward is delivered to the user */
export enum FulfillmentType {
  Automatic = 'AUTOMATIC',
  Instant = 'INSTANT',
  Manual = 'MANUAL'
}

export type GpsCoordinate = {
  __typename?: 'GPSCoordinate';
  altitude?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type GpsCoordinateInput = {
  altitude?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenerateOrgReportInput = {
  /** Render language for the PDF. Defaults to EN if omitted. */
  locale?: InputMaybe<ReportLocale>;
  /** 1–12. Required when MONTHLY. */
  month?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  /** Required when CUSTOM. */
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Required when CUSTOM. */
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  periodType: ReportPeriodType;
  /** 1–4. Required when QUARTERLY. */
  quarter?: InputMaybe<Scalars['Int']['input']>;
  /** Calendar year. Required when MONTHLY or QUARTERLY. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Goal = {
  __typename?: 'Goal';
  createdAt: Scalars['DateTime']['output'];
  currentProgress: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  period: GoalPeriod;
  target: Scalars['Float']['output'];
  type: GoalType;
};

export type GoalInput = {
  period: GoalPeriod;
  target: Scalars['Float']['input'];
  type: GoalType;
};

export enum GoalPeriod {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum GoalType {
  Activities = 'ACTIVITIES',
  Calories = 'CALORIES',
  Distance = 'DISTANCE',
  Steps = 'STEPS'
}

export type HealthDevice = {
  __typename?: 'HealthDevice';
  _id: Scalars['ID']['output'];
  connected: Scalars['Boolean']['output'];
  connectedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  lastCursorUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncCursor?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  provider: HealthProvider;
  syncEnabled: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type HealthDeviceDailyTotal = {
  __typename?: 'HealthDeviceDailyTotal';
  _id: Scalars['ID']['output'];
  calories: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['String']['output'];
  deviceCalories: Scalars['Float']['output'];
  deviceDistance: Scalars['Float']['output'];
  deviceExerciseTime: Scalars['Float']['output'];
  deviceSteps: Scalars['Float']['output'];
  distance: Scalars['Float']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  manualCalories: Scalars['Float']['output'];
  manualDistance: Scalars['Float']['output'];
  manualExerciseTime: Scalars['Float']['output'];
  manualSteps: Scalars['Float']['output'];
  provider: HealthProvider;
  steps: Scalars['Float']['output'];
  totalCalories: Scalars['Float']['output'];
  totalDistance: Scalars['Float']['output'];
  totalExerciseTime: Scalars['Float']['output'];
  totalSteps: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum HealthProvider {
  AppleHealth = 'APPLE_HEALTH',
  Fitbit = 'FITBIT',
  Garmin = 'GARMIN',
  GoogleFit = 'GOOGLE_FIT',
  Strava = 'STRAVA'
}

/** Background sync status for a single health device */
export type HealthSyncDeviceStatus = {
  __typename?: 'HealthSyncDeviceStatus';
  connected: Scalars['Boolean']['output'];
  hoursSinceLastSync: Scalars['Float']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  provider: Scalars['String']['output'];
  status: SyncHealthStatus;
  syncEnabled: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

/** Health sync monitoring payload with devices, stats, and total count */
export type HealthSyncMonitoringPayload = {
  __typename?: 'HealthSyncMonitoringPayload';
  devices: Array<HealthSyncDeviceStatus>;
  /** Stats from the last silent push nudge (from Valkey cache) */
  lastNudgeStats?: Maybe<HealthSyncNudgeStats>;
  stats: HealthSyncMonitoringStats;
  totalCount: Scalars['Int']['output'];
};

/** Aggregate statistics for health sync monitoring */
export type HealthSyncMonitoringStats = {
  __typename?: 'HealthSyncMonitoringStats';
  criticalCount: Scalars['Int']['output'];
  disconnectedCount: Scalars['Int']['output'];
  healthyCount: Scalars['Int']['output'];
  neverSyncedCount: Scalars['Int']['output'];
  totalDevices: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

/** Stats from the last silent push sync nudge */
export type HealthSyncNudgeStats = {
  __typename?: 'HealthSyncNudgeStats';
  /** Duration of the nudge job in ms */
  durationMs: Scalars['Int']['output'];
  /** Failed silent pushes */
  failed: Scalars['Int']['output'];
  /** Per-user failure details (only failed entries) */
  failedUsers: Array<NudgeFailedUser>;
  /** When the last nudge was sent */
  lastNudgeAt?: Maybe<Scalars['DateTime']['output']>;
  /** Successfully sent silent pushes */
  sent: Scalars['Int']['output'];
  /** Total iOS tokens targeted */
  totalTokens: Scalars['Int']['output'];
};

export type HealthTelemetrySampleInput = {
  /** Sample end timestamp in ISO-8601 UTC. */
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional JSON string metadata. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  sampleUuid: Scalars['String']['input'];
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Device/source type for aggregation (e.g. watch | phone | unknown). Provider-specific; used to avoid double-counting when multiple sources exist. */
  sourceProductType?: InputMaybe<Scalars['String']['input']>;
  /** Sample start timestamp in ISO-8601 UTC. */
  startedAt: Scalars['DateTime']['input'];
  /** Timezone offset in seconds captured at sample time. Use native OS value directly. */
  timezoneOffsetSeconds: Scalars['Float']['input'];
  type: HealthTelemetrySampleType;
  /** Unit metadata for value (e.g. count, m, kcal, s). Canonical units: distance=m, active energy=kcal, exercise time=s. */
  unit?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export enum HealthTelemetrySampleType {
  ActiveEnergy = 'ACTIVE_ENERGY',
  BloodOxygen = 'BLOOD_OXYGEN',
  BloodPressureDiastolic = 'BLOOD_PRESSURE_DIASTOLIC',
  BloodPressureSystolic = 'BLOOD_PRESSURE_SYSTOLIC',
  BodyTemperature = 'BODY_TEMPERATURE',
  Calories = 'CALORIES',
  Distance = 'DISTANCE',
  ExerciseTime = 'EXERCISE_TIME',
  HeartRate = 'HEART_RATE',
  HeartRateVariability = 'HEART_RATE_VARIABILITY',
  Height = 'HEIGHT',
  RespiratoryRate = 'RESPIRATORY_RATE',
  RestingHeartRate = 'RESTING_HEART_RATE',
  SleepAnalysis = 'SLEEP_ANALYSIS',
  Steps = 'STEPS',
  Weight = 'WEIGHT'
}

/** Intensity levels for activities */
export enum IntensityLevel {
  High = 'HIGH',
  Low = 'LOW',
  Maximum = 'MAXIMUM',
  Moderate = 'MODERATE',
  Recovery = 'RECOVERY'
}

/** Type of interaction with a lead */
export enum InteractionType {
  Call = 'CALL',
  Email = 'EMAIL',
  Meeting = 'MEETING',
  Note = 'NOTE',
  StatusChange = 'STATUS_CHANGE'
}

export type InviteLinkPayload = {
  __typename?: 'InviteLinkPayload';
  expiresAt: Scalars['DateTime']['output'];
  maxUses: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type JoinChallengeInput = {
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  inviteToken?: InputMaybe<Scalars['String']['input']>;
};

export type JoinEventInput = {
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status: EventParticipantStatus;
};

export type KoinsBalance = {
  __typename?: 'KoinsBalance';
  koinBalance: Scalars['Int']['output'];
  lifetimeKoins: Scalars['Int']['output'];
};

export type KoinsLeaderboardRow = {
  __typename?: 'KoinsLeaderboardRow';
  koins: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type KoinsLedgerEntry = {
  __typename?: 'KoinsLedgerEntry';
  _id: Scalars['ID']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  effectiveAt: Scalars['DateTime']['output'];
  idempotencyKey: Scalars['String']['output'];
  kind: KoinsTransactionKind;
  meta?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  reversalOfLedgerEntryId?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType: KoinsSourceType;
  userId: Scalars['ID']['output'];
};

export type KoinsLedgerHistoryPage = {
  __typename?: 'KoinsLedgerHistoryPage';
  edges: Array<KoinsLedgerEntry>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Source of Koins transaction */
export enum KoinsSourceType {
  Adjustment = 'ADJUSTMENT',
  ChallengeBurn = 'CHALLENGE_BURN',
  ChallengeBuyIn = 'CHALLENGE_BUY_IN',
  ChallengeCreate = 'CHALLENGE_CREATE',
  ChallengePrize = 'CHALLENGE_PRIZE',
  ChallengeRefund = 'CHALLENGE_REFUND',
  EventAttend = 'EVENT_ATTEND',
  FirstPrizeBonus = 'FIRST_PRIZE_BONUS',
  Marketplace = 'MARKETPLACE',
  OnboardingBonus = 'ONBOARDING_BONUS',
  OrganizationBonus = 'ORGANIZATION_BONUS',
  PhysicalActivity = 'PHYSICAL_ACTIVITY',
  Streak_3Day = 'STREAK_3_DAY',
  Streak_7Day = 'STREAK_7_DAY',
  TelemetrySteps = 'TELEMETRY_STEPS'
}

/** Type of Koins transaction */
export enum KoinsTransactionKind {
  Adjustment = 'ADJUSTMENT',
  Burn = 'BURN',
  Earn = 'EARN',
  Reversal = 'REVERSAL',
  Spend = 'SPEND'
}

/** Time window for Koins leaderboard or history */
export enum KoinsWindow {
  All = 'ALL',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** Assigned user summary */
export type LeadAssignedUser = {
  __typename?: 'LeadAssignedUser';
  _id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

/** Filters for querying leads */
export type LeadFiltersInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<LeadSource>>;
  status?: InputMaybe<Array<LeadStatus>>;
  tier?: InputMaybe<Array<LeadTier>>;
};

/** Interaction log entry for a lead */
export type LeadInteractionType = {
  __typename?: 'LeadInteractionType';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  type: InteractionType;
};

/** Pagination parameters */
export type LeadPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** How the lead was captured */
export enum LeadSource {
  Manual = 'MANUAL',
  Referral = 'REFERRAL',
  Website = 'WEBSITE'
}

/** Lead pipeline statistics */
export type LeadStatsType = {
  __typename?: 'LeadStatsType';
  avgDaysToClose: Scalars['Int']['output'];
  byStatus: Array<StatusCount>;
  byTier: Array<TierCount>;
  conversionRate: Scalars['Float']['output'];
  newLeadsThisWeek: Scalars['Int']['output'];
  totalLeads: Scalars['Int']['output'];
};

/** Lead pipeline status */
export enum LeadStatus {
  Contacted = 'CONTACTED',
  DemoCompleted = 'DEMO_COMPLETED',
  DemoScheduled = 'DEMO_SCHEDULED',
  Lost = 'LOST',
  Negotiation = 'NEGOTIATION',
  New = 'NEW',
  Qualified = 'QUALIFIED',
  Won = 'WON'
}

/** Pricing tier the lead is interested in */
export enum LeadTier {
  Enterprise = 'ENTERPRISE',
  Scale = 'SCALE',
  Seed = 'SEED'
}

/** Lead entity */
export type LeadType = {
  __typename?: 'LeadType';
  _id: Scalars['ID']['output'];
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignedToUser?: Maybe<LeadAssignedUser>;
  company: Scalars['String']['output'];
  consentedAt: Scalars['DateTime']['output'];
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  convertedToOrganizationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataRetentionExpiry?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  interactions: Array<LeadInteractionType>;
  isActive: Scalars['Boolean']['output'];
  landingPage?: Maybe<Scalars['String']['output']>;
  lastContactedAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextFollowUpAt?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  qualificationScore: Scalars['Int']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  size: CompanySize;
  source: LeadSource;
  status: LeadStatus;
  tier: LeadTier;
  updatedAt: Scalars['DateTime']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

/** Controls how the user's name appears on leaderboards / participant lists to OTHER users. Privacy-by-default (FIRST_NAME_INITIAL). */
export enum LeaderboardVisibility {
  Anonymous = 'ANONYMOUS',
  FirstNameInitial = 'FIRST_NAME_INITIAL',
  Full = 'FULL'
}

/** Scope for challenge/event listing: organization-only or including all public */
export enum ListingScope {
  All = 'ALL',
  Organization = 'ORGANIZATION'
}

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MagicLinkInput = {
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MagicLinkPayload = {
  __typename?: 'MagicLinkPayload';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reviewVerifyToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Category of marketplace reward item */
export enum MarketplaceCategory {
  Donation = 'DONATION',
  Experience = 'EXPERIENCE',
  GiftCard = 'GIFT_CARD',
  Merchandise = 'MERCHANDISE',
  Other = 'OTHER',
  Perk = 'PERK'
}

/** A reward item available in the marketplace */
export type MarketplaceItemType = {
  __typename?: 'MarketplaceItemType';
  _id: Scalars['ID']['output'];
  /** Whether inventory auto-refills monthly */
  autoRefill: Scalars['Boolean']['output'];
  category: MarketplaceCategory;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  featured: Scalars['Boolean']['output'];
  /** Internal fulfillment instructions (admin only) */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  fulfillmentType: FulfillmentType;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  koinsPrice: Scalars['Int']['output'];
  /** Last refill timestamp */
  lastRefilledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Extensible JSON metadata */
  metadata?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Day of month (1-28) to refill */
  refillDay: Scalars['Int']['output'];
  /** Quantity to restock */
  refillQuantity?: Maybe<Scalars['Int']['output']>;
  /** Remaining inventory (null = unlimited) */
  remainingInventory?: Maybe<Scalars['Int']['output']>;
  scope: MarketplaceScope;
  shortDescription?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  /** Total inventory (null = unlimited) */
  totalInventory?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter options for browsing marketplace items */
export type MarketplaceItemsFilterInput = {
  category?: InputMaybe<MarketplaceCategory>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Text search on name + description */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated marketplace items response */
export type MarketplaceItemsResponse = {
  __typename?: 'MarketplaceItemsResponse';
  hasMore: Scalars['Boolean']['output'];
  items: Array<MarketplaceItemType>;
  total: Scalars['Int']['output'];
};

/** A marketplace order (purchase record) */
export type MarketplaceOrderType = {
  __typename?: 'MarketplaceOrderType';
  _id: Scalars['ID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fulfilledAt?: Maybe<Scalars['DateTime']['output']>;
  fulfillmentDetails?: Maybe<Scalars['String']['output']>;
  /** The purchased item details */
  item?: Maybe<MarketplaceItemType>;
  koinsSpent: Scalars['Int']['output'];
  marketplaceItemId: Scalars['ID']['output'];
  sharePublicly?: Maybe<Scalars['Boolean']['output']>;
  shoutoutSentAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrderStatus;
  updatedAt: Scalars['DateTime']['output'];
  /** User who placed the order (admin view) */
  user?: Maybe<OrderUserSummaryType>;
  userId: Scalars['ID']['output'];
};

/** Paginated marketplace orders response */
export type MarketplaceOrdersResponse = {
  __typename?: 'MarketplaceOrdersResponse';
  hasMore: Scalars['Boolean']['output'];
  orders: Array<MarketplaceOrderType>;
  total: Scalars['Int']['output'];
};

/** Visibility scope of a marketplace item */
export enum MarketplaceScope {
  Global = 'GLOBAL',
  Organization = 'ORGANIZATION'
}

export type MetricField = {
  __typename?: 'MetricField';
  allowedUnits?: Maybe<Array<Scalars['String']['output']>>;
  defaultValue?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  required: Scalars['Boolean']['output'];
  type: MetricType;
  unit: Scalars['String']['output'];
  userEditable: Scalars['Boolean']['output'];
};

export type MetricFieldInput = {
  allowedUnits?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: MetricType;
  unit: Scalars['String']['input'];
  userEditable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type of metric that can be tracked for activities */
export enum MetricType {
  Cadence = 'CADENCE',
  Calories = 'CALORIES',
  Custom = 'CUSTOM',
  Distance = 'DISTANCE',
  Duration = 'DURATION',
  Elevation = 'ELEVATION',
  HeartRate = 'HEART_RATE',
  Pace = 'PACE',
  Power = 'POWER',
  Repetitions = 'REPETITIONS',
  Sets = 'SETS',
  Speed = 'SPEED',
  Steps = 'STEPS',
  Temperature = 'TEMPERATURE',
  Weight = 'WEIGHT'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptPolicy: AuthPayload;
  adjustKoins: KoinsLedgerEntry;
  /** Add interaction to lead timeline (ADMIN only) */
  adminAddLeadInteraction: LeadType;
  /** Assign lead to an admin user (ADMIN only) */
  adminAssignLead: LeadType;
  /** Convert lead to organization (ADMIN only) */
  adminConvertLead: ConvertLeadResultType;
  /** Create a lead manually (ADMIN only) */
  adminCreateLead: LeadType;
  /** Create an organization with an initial ORG_ADMIN assignment (ADMIN only) */
  adminCreateOrganization: AdminCreateOrganizationResult;
  /** Soft-delete a lead (ADMIN only) */
  adminDeleteLead: Scalars['Boolean']['output'];
  /** Update lead fields (ADMIN only) */
  adminUpdateLead: LeadType;
  /** Update lead status with state machine validation (ADMIN only) */
  adminUpdateLeadStatus: LeadType;
  bulkImportUsers: BulkImportUsersReport;
  cancelDeletionRequest: CancellationResult;
  /** Cancel a marketplace order and refund Koins */
  cancelOrder: MarketplaceOrderType;
  claimBonus: ClaimBonusResult;
  /** Clean old completed or failed jobs (ADMIN only) */
  cleanQueueJobs: Scalars['Int']['output'];
  cleanupExpiredTokens: MagicLinkPayload;
  confirmUpload: UploadConfirmationResponse;
  connectDevice: HealthDevice;
  createActivity: Activity;
  createActivityType: ActivityType;
  createChallenge: Challenge;
  createChallengeInvite: InviteLinkPayload;
  createEvent: Event;
  createEventInvite: InviteLinkPayload;
  /** Create a new marketplace reward item (admin) */
  createMarketplaceItem: MarketplaceItemType;
  createOrganization: Organization;
  deactivateAccount: User;
  /** Deactivate a marketplace item (soft-delete) */
  deactivateMarketplaceItem: MarketplaceItemType;
  deactivateNotificationTemplate: Scalars['Boolean']['output'];
  deleteActivity: Activity;
  deleteActivityType: ActivityType;
  /** Soft-delete an engagement report. The PDF is purged from S3 immediately; the row stays for the audit trail until the 12-month TTL reaps it. Allowed when status is COMPLETE or FAILED — in-flight reports must be left to finish. */
  deleteOrgReport: OrgReport;
  deleteOrganization: Organization;
  /** Disconnect an organization's chat integration and revoke the bot token */
  disconnectChatIntegration: Scalars['Boolean']['output'];
  disconnectDevice: HealthDevice;
  duplicateActivity: Activity;
  editActivity: EditActivityResult;
  /** ADMIN: Enroll registered users who are on the roster but not yet members (post-upgrade) */
  enrollPendingRosterUsers: EnrollPendingResult;
  /** Fulfill a marketplace order (admin) */
  fulfillOrder: MarketplaceOrderType;
  /** Trigger generation of an engagement report. Async — returns immediately with status PENDING; poll orgReports to track progress. */
  generateOrgReport: OrgReport;
  /** Initiate a Slack OAuth flow. Returns the authorization URL to open in a popup. */
  initiateChatIntegration: Scalars['String']['output'];
  inviteToOrganization: OrganizationMember;
  joinChallenge: Challenge;
  joinEvent: Event;
  joinOrganization: Organization;
  leaveChallenge: Challenge;
  leaveEvent: Event;
  leaveOrganization: Organization;
  login: AuthPayload;
  logout: Scalars['Boolean']['output'];
  /** Promote a delayed job to run immediately (ADMIN only) */
  promoteQueueJob: Scalars['Boolean']['output'];
  promoteUser: User;
  publishChallenge: Challenge;
  publishEvent: Event;
  /** Purchase a reward from the marketplace. The `idempotencyKey` is a client-generated UUID that MUST be regenerated per user-initiated purchase and reused on retries so the backend can de-duplicate. */
  purchaseMarketplaceItem: MarketplaceOrderType;
  /** Reactivate a suspended organization */
  reactivateOrganization: Organization;
  recalculateActivityMetrics: Activity;
  recomputeUserKoins: KoinsBalance;
  recordAnalyticsEvents: RecordAnalyticsResult;
  refreshAccessToken: AuthPayload;
  /** Refresh the status of a pending or connected chat integration by validating the token */
  refreshChatIntegrationStatus: ChatIntegrationType;
  /** Refresh today's organization stats inline, backfill gaps in background */
  refreshOrganizationStats: Scalars['Boolean']['output'];
  /** Refund a fulfilled marketplace order (ADMIN only) */
  refundOrder: MarketplaceOrderType;
  /** Regenerate an existing engagement report. Deletes the old PDF from S3, re-runs metrics + PDF generation, and re-uses the same OrgReport row. Allowed when status is COMPLETE or FAILED; rejected while a run is in flight. */
  regenerateOrgReport: OrgReport;
  register: AuthPayload;
  registerPushToken: Scalars['Boolean']['output'];
  removeFromOrganization: Organization;
  /** Remove a specific job (ADMIN only) */
  removeQueueJob: Scalars['Boolean']['output'];
  requestDataDeletion: DeletionRequestResult;
  requestMagicLink: MagicLinkPayload;
  requestUploadUrl: PresignedUploadResponse;
  /** Retry all failed jobs in a queue (ADMIN only) */
  retryAllFailedJobs: Scalars['Int']['output'];
  /** Retry a specific failed job (ADMIN only) */
  retryQueueJob: Scalars['Boolean']['output'];
  revokePolicy: RevokePolicyResponse;
  saveNotificationTemplate: NotificationTemplateType;
  /** Select the broadcast channel for an organization's chat integration */
  selectBroadcastChannel: ChatIntegrationType;
  sendAdminNotification: Scalars['Boolean']['output'];
  /** Send magic link invite emails to selected roster entries */
  sendRosterInvites: SendRosterInvitesReport;
  sendTestEmail: MagicLinkPayload;
  setGoals: User;
  setLocale: User;
  setPassword: MagicLinkPayload;
  spendKoins: KoinsLedgerEntry;
  stopChallengeRecurrence: Challenge;
  stopEventRecurrence: Event;
  submitFeedback: FeedbackResponse;
  /** Suspend an organization — cascades to members and marketplace items */
  suspendOrganization: Organization;
  switchToPasswordlessAuth: MagicLinkPayload;
  syncHealthTelemetry: SyncHealthTelemetryPayload;
  /** Send a test message to the configured broadcast channel. Rate limited to 1 per 5 minutes per org. */
  testBroadcast: Scalars['Boolean']['output'];
  unregisterPushToken: Scalars['Boolean']['output'];
  updateActivity: Activity;
  updateActivityType: ActivityType;
  /** Update which broadcast types are enabled for an organization */
  updateBroadcastSettings: ChatIntegrationType;
  updateChallenge: Challenge;
  /** Update economy configuration values (Admin only). Only provided fields are updated. */
  updateEconomyConfig: EconomyConfigType;
  updateEvent: Event;
  updateHealthProfile: User;
  updateLeaderboardVisibility: User;
  /** Update a marketplace reward item (admin) */
  updateMarketplaceItem: MarketplaceItemType;
  updateMemberRole: OrganizationMember;
  updateNotificationPreferences: NotificationPreferenceType;
  updateOnboardingProgress: User;
  updateOrganization: Organization;
  updateOrganizationMember: OrganizationMember;
  updateOrganizationSSO: Organization;
  /** ADMIN: Update an organization's pricing tier and optional seat limit override */
  updateOrganizationTier: UpdateOrganizationTierResult;
  updateProfile: User;
  verifyMagicLink: AuthPayload;
};


export type MutationAcceptPolicyArgs = {
  input: AcceptPolicyInput;
};


export type MutationAdjustKoinsArgs = {
  input: AdjustKoinsInput;
};


export type MutationAdminAddLeadInteractionArgs = {
  input: AddLeadInteractionInput;
};


export type MutationAdminAssignLeadArgs = {
  input: AssignLeadInput;
};


export type MutationAdminConvertLeadArgs = {
  input: ConvertLeadInput;
};


export type MutationAdminCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationAdminCreateOrganizationArgs = {
  input: AdminCreateOrganizationInput;
};


export type MutationAdminDeleteLeadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminUpdateLeadArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeadInput;
};


export type MutationAdminUpdateLeadStatusArgs = {
  input: UpdateLeadStatusInput;
};


export type MutationBulkImportUsersArgs = {
  file: Scalars['Upload']['input'];
  input?: InputMaybe<BulkImportUsersInput>;
  organizationId: Scalars['ID']['input'];
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationClaimBonusArgs = {
  input: ClaimBonusInput;
};


export type MutationCleanQueueJobsArgs = {
  gracePeriodHours?: InputMaybe<Scalars['Int']['input']>;
  queueName: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationConfirmUploadArgs = {
  key: Scalars['String']['input'];
};


export type MutationConnectDeviceArgs = {
  input: ConnectDeviceInput;
};


export type MutationCreateActivityArgs = {
  input: CreateActivityInput;
};


export type MutationCreateActivityTypeArgs = {
  input: CreateActivityTypeInput;
};


export type MutationCreateChallengeArgs = {
  input: CreateChallengeInput;
};


export type MutationCreateChallengeInviteArgs = {
  challengeId: Scalars['ID']['input'];
  options?: InputMaybe<CreateInviteOptionsInput>;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateEventInviteArgs = {
  eventId: Scalars['ID']['input'];
  options?: InputMaybe<CreateInviteOptionsInput>;
};


export type MutationCreateMarketplaceItemArgs = {
  input: CreateMarketplaceItemInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationDeactivateMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateNotificationTemplateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationDeleteActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteActivityTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrgReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisconnectChatIntegrationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationDisconnectDeviceArgs = {
  provider: HealthProvider;
};


export type MutationDuplicateActivityArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditActivityArgs = {
  input: EditActivityInput;
};


export type MutationEnrollPendingRosterUsersArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationFulfillOrderArgs = {
  fulfillmentDetails?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type MutationGenerateOrgReportArgs = {
  input: GenerateOrgReportInput;
};


export type MutationInitiateChatIntegrationArgs = {
  organizationId: Scalars['ID']['input'];
  provider: ChatProviderType;
};


export type MutationInviteToOrganizationArgs = {
  department?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationJoinChallengeArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<JoinChallengeInput>;
};


export type MutationJoinEventArgs = {
  id: Scalars['ID']['input'];
  input: JoinEventInput;
};


export type MutationJoinOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationLeaveChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeaveEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeaveOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLogoutArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPromoteQueueJobArgs = {
  jobId: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
};


export type MutationPromoteUserArgs = {
  newRole: UserRole;
  userId: Scalars['ID']['input'];
};


export type MutationPublishChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPurchaseMarketplaceItemArgs = {
  idempotencyKey: Scalars['String']['input'];
  marketplaceItemId: Scalars['ID']['input'];
  sharePublicly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationReactivateOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRecalculateActivityMetricsArgs = {
  forceRecalculate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRecomputeUserKoinsArgs = {
  targetUserId: Scalars['ID']['input'];
};


export type MutationRecordAnalyticsEventsArgs = {
  input: RecordAnalyticsEventsInput;
};


export type MutationRefreshAccessTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRefreshChatIntegrationStatusArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRefreshOrganizationStatsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRefundOrderArgs = {
  orderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRegenerateOrgReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRegisterPushTokenArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRemoveFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveQueueJobArgs = {
  isDlq?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
};


export type MutationRequestDataDeletionArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestMagicLinkArgs = {
  input: MagicLinkInput;
};


export type MutationRequestUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  purpose: UploadPurpose;
};


export type MutationRetryAllFailedJobsArgs = {
  isDlq?: InputMaybe<Scalars['Boolean']['input']>;
  queueName: Scalars['String']['input'];
};


export type MutationRetryQueueJobArgs = {
  isDlq?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
};


export type MutationRevokePolicyArgs = {
  input: RevokePolicyInput;
};


export type MutationSaveNotificationTemplateArgs = {
  input: SaveNotificationTemplateInput;
};


export type MutationSelectBroadcastChannelArgs = {
  input: SelectBroadcastChannelInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationSendAdminNotificationArgs = {
  input: SendAdminNotificationInput;
};


export type MutationSendRosterInvitesArgs = {
  emails: Array<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationSendTestEmailArgs = {
  data: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  template: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationSetGoalsArgs = {
  input: SetGoalsInput;
};


export type MutationSetLocaleArgs = {
  locale: UserLocale;
};


export type MutationSetPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationSpendKoinsArgs = {
  input: SpendKoinsInput;
};


export type MutationStopChallengeRecurrenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStopEventRecurrenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitFeedbackArgs = {
  input: FeedbackInput;
};


export type MutationSuspendOrganizationArgs = {
  input: SuspendOrganizationInput;
};


export type MutationSyncHealthTelemetryArgs = {
  input: SyncHealthTelemetryInput;
};


export type MutationTestBroadcastArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationUnregisterPushTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateActivityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateActivityInput;
};


export type MutationUpdateActivityTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateActivityTypeInput;
};


export type MutationUpdateBroadcastSettingsArgs = {
  input: UpdateBroadcastSettingsInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationUpdateChallengeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateChallengeInput;
};


export type MutationUpdateEconomyConfigArgs = {
  input: UpdateEconomyConfigInput;
};


export type MutationUpdateEventArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEventInput;
};


export type MutationUpdateHealthProfileArgs = {
  age?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateLeaderboardVisibilityArgs = {
  value: LeaderboardVisibility;
};


export type MutationUpdateMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMarketplaceItemInput;
};


export type MutationUpdateMemberRoleArgs = {
  organizationId: Scalars['ID']['input'];
  role: OrganizationRole;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateNotificationPreferencesArgs = {
  input: UpdateNotificationPreferencesInput;
};


export type MutationUpdateOnboardingProgressArgs = {
  step: Scalars['Int']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationMemberArgs = {
  input: OrganizationMemberInput;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationSsoArgs = {
  input: UpdateOrganizationSsoInput;
};


export type MutationUpdateOrganizationTierArgs = {
  input: UpdateOrganizationTierInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationUpdateProfileArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyMagicLinkArgs = {
  input: VerifyMagicLinkInput;
};

export type MyFairnessData = {
  __typename?: 'MyFairnessData';
  /** Stored age in years; null if not set. */
  age?: Maybe<Scalars['Float']['output']>;
  /** Fairness multiplier applied to Koin earnings right now (1.0–1.5). Falls back to 1.0 when consent is revoked or metrics are missing. */
  currentMultiplier: Scalars['Float']['output'];
  /** True when HEALTH_DATA and FAIRNESS_DATA consent are both active. */
  hasFairnessConsent: Scalars['Boolean']['output'];
  /** Stored height in centimetres; null if not set. */
  height?: Maybe<Scalars['Float']['output']>;
  /** Stored weight in kilograms; null if not set. */
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for user's order history */
export type MyOrdersFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrderStatus>;
};

/** A single notification log entry for monitoring */
export type NotificationLogEntry = {
  __typename?: 'NotificationLogEntry';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Notification log monitoring payload with entries, stats, and total count */
export type NotificationLogMonitoringPayload = {
  __typename?: 'NotificationLogMonitoringPayload';
  entries: Array<NotificationLogEntry>;
  stats: NotificationLogMonitoringStats;
  totalCount: Scalars['Int']['output'];
};

/** Aggregate statistics for notification log monitoring */
export type NotificationLogMonitoringStats = {
  __typename?: 'NotificationLogMonitoringStats';
  deliveredCount: Scalars['Int']['output'];
  droppedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  queuedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NotificationPreferenceType = {
  __typename?: 'NotificationPreferenceType';
  availableTypes: Array<NotificationType>;
  disabledTypes: Array<NotificationType>;
  pushEnabled: Scalars['Boolean']['output'];
};

export type NotificationPreviewType = {
  __typename?: 'NotificationPreviewType';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
  validation: ValidationResultType;
};

export type NotificationTemplateType = {
  __typename?: 'NotificationTemplateType';
  _id: Scalars['String']['output'];
  body: Scalars['String']['output'];
  category: Scalars['String']['output'];
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  sound?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variables: Array<TemplateVariableType>;
  version: Scalars['String']['output'];
};

/** Categories of push notifications */
export enum NotificationType {
  ActivityUpdates = 'ACTIVITY_UPDATES',
  ChallengeEnded = 'CHALLENGE_ENDED',
  ChallengeNewMember = 'CHALLENGE_NEW_MEMBER',
  ChallengeProgress = 'CHALLENGE_PROGRESS',
  ChallengeStarting = 'CHALLENGE_STARTING',
  EventNewMember = 'EVENT_NEW_MEMBER',
  EventReminder = 'EVENT_REMINDER',
  General = 'GENERAL',
  KoinsMilestone = 'KOINS_MILESTONE',
  Marketplace = 'MARKETPLACE',
  OrgUpdates = 'ORG_UPDATES',
  Reminders = 'REMINDERS',
  SocialUpdates = 'SOCIAL_UPDATES',
  StreakUpdates = 'STREAK_UPDATES',
  WeeklySummary = 'WEEKLY_SUMMARY'
}

/** A user whose silent push nudge failed */
export type NudgeFailedUser = {
  __typename?: 'NudgeFailedUser';
  /** Error type from push provider (e.g. DeviceNotRegistered) */
  errorType: Scalars['String']['output'];
  /** User ID whose nudge failed */
  userId: Scalars['String']['output'];
};

export type OnboardingContext = {
  __typename?: 'OnboardingContext';
  memberships: Array<OnboardingOrganizationMembership>;
  prefill: OnboardingPrefill;
  screen1Mode: OnboardingScreen1Mode;
};

export type OnboardingOrganization = {
  __typename?: 'OnboardingOrganization';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: OrganizationType;
};

export type OnboardingOrganizationMembership = {
  __typename?: 'OnboardingOrganizationMembership';
  department?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeStatus?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  joinedAt: Scalars['DateTime']['output'];
  organization: OnboardingOrganization;
  organizationId: Scalars['ID']['output'];
  role: OrganizationRole;
  workLocation?: Maybe<Scalars['String']['output']>;
};

export type OnboardingPrefill = {
  __typename?: 'OnboardingPrefill';
  department?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizations: Array<OnboardingOrganization>;
};

/** Backend-decided mode for onboarding screen 1 */
export enum OnboardingScreen1Mode {
  Empty = 'EMPTY',
  Prefill = 'PREFILL'
}

/** Status of a marketplace order */
export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED'
}

/** Lightweight user summary for admin order display */
export type OrderUserSummaryType = {
  __typename?: 'OrderUserSummaryType';
  _id: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** A generated HR engagement report for an organization. Status drives admin-portal UI; downloadUrl is a short-lived presigned link. */
export type OrgReport = {
  __typename?: 'OrgReport';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Short-lived presigned S3 GetObject URL (48 h TTL). Re-fetched on every query; never persisted client-side. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  generatedBy?: Maybe<User>;
  locale: ReportLocale;
  metrics?: Maybe<OrgReportMetricsType>;
  organizationId: Scalars['ID']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodLabel: Scalars['String']['output'];
  periodStart: Scalars['DateTime']['output'];
  periodType: ReportPeriodType;
  status: ReportStatus;
};

export type OrgReportMetricsType = {
  __typename?: 'OrgReportMetricsType';
  activeEmployeeRate: Scalars['Float']['output'];
  activityConsentRate: Scalars['Float']['output'];
  adoptionRate: Scalars['Float']['output'];
  avgDailyStepsPerActiveEmployee: Scalars['Float']['output'];
  budgetUtilizationRate: Scalars['Float']['output'];
  challengeParticipationRate: Scalars['Float']['output'];
  challengesCompleted: Scalars['Int']['output'];
  dauMauRatio: Scalars['Float']['output'];
  estimatedRewardValueEur: Scalars['Float']['output'];
  eventAttendanceRate: Scalars['Float']['output'];
  eventsHeld: Scalars['Int']['output'];
  healthConsentRate: Scalars['Float']['output'];
  koinsInCirculation: Scalars['Float']['output'];
  manualActivityCount: Scalars['Int']['output'];
  marketplaceRedemptions: Scalars['Int']['output'];
  marketplaceRedemptionsByCategory: Array<CategoryCount>;
  newActivationsInPeriod: Scalars['Int']['output'];
  previousPeriod: PreviousPeriodSnapshot;
  streakAchievementRate: Scalars['Float']['output'];
  suppressedDueToLowMembership: Scalars['Boolean']['output'];
  topActivityTypes: Array<ActivityTypeCount>;
  totalActiveMembers: Scalars['Int']['output'];
  totalCalories: Scalars['Float']['output'];
  /** Aggregate distance in metres. Convert to km in the UI. */
  totalDistanceMeters: Scalars['Float']['output'];
  /** Aggregate active minutes (from HealthDeviceDailyTotal.totalExerciseTime). */
  totalExerciseMinutes: Scalars['Float']['output'];
  totalInvitedMembers: Scalars['Int']['output'];
  totalKoinsEarned: Scalars['Float']['output'];
  totalKoinsSpent: Scalars['Float']['output'];
  totalSteps: Scalars['Float']['output'];
  trends: ReportTrends;
};

export type Organization = {
  __typename?: 'Organization';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Resolved seat limit (null = unlimited) */
  effectiveMaxUsers?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  /** Custom seat limit override (null = use tier/type default) */
  maxUsers?: Maybe<Scalars['Int']['output']>;
  memberCount: Scalars['Int']['output'];
  members?: Maybe<Array<OrganizationMember>>;
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  /** Current seat usage and capacity */
  seatUsage?: Maybe<SeatUsage>;
  /** URL-safe slug for routing (e.g., 'acme-corp-gmbh') */
  slug?: Maybe<Scalars['String']['output']>;
  /** SSO configuration. Visible to ORG_ADMIN and ADMIN only. */
  sso?: Maybe<OrganizationSsoConfigType>;
  tier: OrganizationTier;
  /** IANA timezone (default Europe/Berlin). Used for org-local date math in reports and analytics. */
  timezone: Scalars['String']['output'];
  type: OrganizationType;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type OrganizationMembersArgs = {
  input?: InputMaybe<OrganizationMembersInput>;
};

export type OrganizationChallengesResult = {
  __typename?: 'OrganizationChallengesResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Challenge>;
  totalCount: Scalars['Int']['output'];
};

/** Full dashboard response for an organization */
export type OrganizationDashboardResponse = {
  __typename?: 'OrganizationDashboardResponse';
  currentPeriod: PeriodStats;
  dailyBreakdown: Array<DailyBreakdown>;
  previousPeriod: PeriodStats;
  trend: DashboardTrend;
};

/** Extended org details for ADMIN drill-down */
export type OrganizationDetailAdmin = {
  __typename?: 'OrganizationDetailAdmin';
  activeChallengeCount: Scalars['Int']['output'];
  activeEventCount: Scalars['Int']['output'];
  activeMarketplaceItemCount: Scalars['Int']['output'];
  memberCount: Scalars['Int']['output'];
  organization: Organization;
  rosterCount: Scalars['Int']['output'];
  totalKoinsEarned: Scalars['Int']['output'];
  totalKoinsSpent: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
};

export type OrganizationEventsResult = {
  __typename?: 'OrganizationEventsResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Event>;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationFiltersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<OrganizationType>>;
};

/** Filter options for org-scoped marketplace items */
export type OrganizationMarketplaceItemsInput = {
  category?: InputMaybe<MarketplaceCategory>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include deactivated items (default false) */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  /** Text search on name + description */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeStatus?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  joinedAt: Scalars['DateTime']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  role: OrganizationRole;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  workLocation?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMemberInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employeeStatus?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMembersInput = {
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<OrganizationRole>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Order stats for an organization */
export type OrganizationOrderStatsType = {
  __typename?: 'OrganizationOrderStatsType';
  cancelledCount: Scalars['Int']['output'];
  fulfilledCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  totalKoinsSpent: Scalars['Int']['output'];
};

/** Filter options for org-scoped orders */
export type OrganizationOrdersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<OrderStatus>;
};

/** Role of a member within an organization */
export enum OrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

/** A single roster entry with enrollment status */
export type OrganizationRosterEntry = {
  __typename?: 'OrganizationRosterEntry';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeStatus?: Maybe<Scalars['String']['output']>;
  enrollmentStatus: RosterEnrollmentStatus;
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workEmail: Scalars['String']['output'];
};

/** Filters for the organizationRoster query */
export type OrganizationRosterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RosterEnrollmentStatus>;
};

/** Paginated roster result */
export type OrganizationRosterResult = {
  __typename?: 'OrganizationRosterResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<OrganizationRosterEntry>;
  total: Scalars['Int']['output'];
};

/** Quick stats for the roster page header */
export type OrganizationRosterStats = {
  __typename?: 'OrganizationRosterStats';
  activeUsers: Scalars['Int']['output'];
  notInvited: Scalars['Int']['output'];
  pendingInvites: Scalars['Int']['output'];
  totalEntries: Scalars['Int']['output'];
};

export type OrganizationSsoConfigType = {
  __typename?: 'OrganizationSSOConfigType';
  domainsVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  emailDomains: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  enforced: Scalars['Boolean']['output'];
  google?: Maybe<OrganizationSsoGoogleConfigType>;
  microsoft?: Maybe<OrganizationSsoMicrosoftConfigType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationSsoGoogleConfigType = {
  __typename?: 'OrganizationSSOGoogleConfigType';
  allowJIT: Scalars['Boolean']['output'];
  hostedDomain: Scalars['String']['output'];
};

export type OrganizationSsoMicrosoftConfigType = {
  __typename?: 'OrganizationSSOMicrosoftConfigType';
  allowJIT: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

/** Fields available for sorting organizations */
export enum OrganizationSortField {
  CreatedAt = 'CREATED_AT',
  MemberCount = 'MEMBER_COUNT',
  Name = 'NAME',
  Type = 'TYPE'
}

export type OrganizationSortInput = {
  field?: InputMaybe<OrganizationSortField>;
  order?: InputMaybe<SortOrder>;
};

/** Filter for organization active status */
export enum OrganizationStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Suspended = 'SUSPENDED'
}

/** Pricing tier for commercial organizations */
export enum OrganizationTier {
  Enterprise = 'ENTERPRISE',
  Scale = 'SCALE',
  Seed = 'SEED'
}

/** Type of organization */
export enum OrganizationType {
  Commercial = 'COMMERCIAL',
  Ngo = 'NGO',
  Npo = 'NPO'
}

/** Controls how the conflict-detection engine treats manual activities of this type when checking for device-data overlap */
export enum OverlapEligibility {
  FullOverlap = 'FULL_OVERLAP',
  ManualOnly = 'MANUAL_ONLY',
  NoOverlap = 'NO_OVERLAP'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Paginated leads result */
export type PaginatedLeadsResult = {
  __typename?: 'PaginatedLeadsResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<LeadType>;
  total: Scalars['Int']['output'];
};

/** Aggregated metrics for a period */
export type PeriodStats = {
  __typename?: 'PeriodStats';
  _suppressed?: Maybe<Scalars['Boolean']['output']>;
  activeMembers: Scalars['Int']['output'];
  activeMembersPercentage: Scalars['Float']['output'];
  totalActivities: Scalars['Int']['output'];
  totalChallengesActive: Scalars['Int']['output'];
  totalChallengesCompleted: Scalars['Int']['output'];
  totalChallengesUpcoming: Scalars['Int']['output'];
  totalEventsActive: Scalars['Int']['output'];
  totalEventsCompleted: Scalars['Int']['output'];
  totalEventsUpcoming: Scalars['Int']['output'];
  totalKoinsEarned: Scalars['Int']['output'];
  totalKoinsSpent: Scalars['Int']['output'];
  totalMembers: Scalars['Int']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type Policy = {
  __typename?: 'Policy';
  _id: Scalars['ID']['output'];
  availableLocales: Array<UserLocale>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  isRequiredForRegistration: Scalars['Boolean']['output'];
  requiresReconsent: Scalars['Boolean']['output'];
  resolvedLocale?: Maybe<UserLocale>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: PolicyType;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['DateTime']['output'];
};

/** Consent history event action */
export enum PolicyConsentAction {
  Accept = 'ACCEPT',
  DeletionCancelled = 'DELETION_CANCELLED',
  DeletionExecuted = 'DELETION_EXECUTED',
  DeletionRequested = 'DELETION_REQUESTED',
  Revoke = 'REVOKE'
}

export type PolicyConsentHistoryPage = {
  __typename?: 'PolicyConsentHistoryPage';
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<PolicyConsentLogType>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolicyConsentInput = {
  type: PolicyType;
  version: Scalars['DateTime']['input'];
};

export type PolicyConsentLogType = {
  __typename?: 'PolicyConsentLogType';
  _id: Scalars['ID']['output'];
  action: PolicyConsentAction;
  actorUserId?: Maybe<Scalars['ID']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  policyType: PolicyType;
  policyVersion: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type PolicyConsentType = {
  __typename?: 'PolicyConsentType';
  acceptedAt: Scalars['DateTime']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isRevoked?: Maybe<Scalars['Boolean']['output']>;
  policyVersion: Scalars['DateTime']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  type: PolicyType;
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** Types of GDPR policies */
export enum PolicyType {
  ActivityData = 'ACTIVITY_DATA',
  Analytics = 'ANALYTICS',
  ComprehensivePrivacyPolicy = 'COMPREHENSIVE_PRIVACY_POLICY',
  FairnessData = 'FAIRNESS_DATA',
  HealthData = 'HEALTH_DATA',
  LocationData = 'LOCATION_DATA',
  MarketingConsent = 'MARKETING_CONSENT',
  PersonalData = 'PERSONAL_DATA',
  TermsOfService = 'TERMS_OF_SERVICE'
}

export type PresignedUploadResponse = {
  __typename?: 'PresignedUploadResponse';
  cdnUrl: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type PreviewNotificationTemplateInput = {
  body: Scalars['String']['input'];
  /** JSON string of sample variables */
  sampleVariables: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type PreviousPeriodSnapshot = {
  __typename?: 'PreviousPeriodSnapshot';
  activeEmployeeRate: Scalars['Float']['output'];
  challengeParticipationRate: Scalars['Float']['output'];
  marketplaceRedemptions: Scalars['Int']['output'];
  totalKoinsEarned: Scalars['Float']['output'];
  totalSteps: Scalars['Float']['output'];
};

export type PrizeDistributionType = {
  __typename?: 'PrizeDistributionType';
  percentage: Scalars['Float']['output'];
  rank: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  activities: Array<Activity>;
  activity?: Maybe<Activity>;
  activityHistory: Array<DailyActivitySummary>;
  activityStats: ActivityStats;
  activityType?: Maybe<ActivityType>;
  activityTypeByName?: Maybe<ActivityType>;
  activityTypeCategories: Array<Scalars['String']['output']>;
  activityTypeTags: Array<Scalars['String']['output']>;
  activityTypes: Array<ActivityType>;
  /** Export leads as CSV (ADMIN only) */
  adminExportLeads: Scalars['String']['output'];
  /** ADMIN-only: Monitor background health sync status across all devices. GDPR-safe — no health data or PII. */
  adminHealthSyncMonitoring: HealthSyncMonitoringPayload;
  /** Get lead detail by ID (ADMIN only) */
  adminLeadDetail: LeadType;
  /** Get lead pipeline statistics (ADMIN only) */
  adminLeadStats: LeadStatsType;
  /** List leads with filters and pagination (ADMIN only) */
  adminLeads: PaginatedLeadsResult;
  /** List all marketplace items for admin management */
  adminMarketplaceItems: MarketplaceItemsResponse;
  /** ADMIN-only: Monitor notification delivery logs. GDPR-safe — shows pseudo-anonymous userIds and delivery status only. */
  adminNotificationLogMonitoring: NotificationLogMonitoringPayload;
  adminPolicyConsentHistory: PolicyConsentHistoryPage;
  /** Get most recent leads (ADMIN only) */
  adminRecentLeads: Array<LeadType>;
  /** Search users globally by email or name (ADMIN only) */
  adminSearchUsers: AdminSearchUsersResult;
  /** Get detailed user profile with org memberships for admin support (ADMIN only) */
  adminUserDetail: AdminUserDetail;
  /** View any user's Koin transaction ledger for support/audit (ADMIN only) */
  adminUserLedger: AdminUserLedgerPage;
  /** List all marketplace orders (admin) */
  allOrders: MarketplaceOrdersResponse;
  /** Paginated list of all organizations (ADMIN only) */
  allOrganizations: AllOrganizationsResult;
  /** Breakdown of one event by a single dimension (ranked, long-tail capped) */
  analyticsBreakdown: Array<AnalyticsBreakdownPoint>;
  /** Canonical analytics event allowlist (for the admin event picker) */
  analyticsEvents: Array<Scalars['String']['output']>;
  /** Daily counters for one event, rolled up to the requested granularity */
  analyticsTimeSeries: Array<AnalyticsTimeSeriesPoint>;
  /** Top events by total count over the range (limit clamped to 100) */
  analyticsTopEvents: Array<AnalyticsTopEventPoint>;
  /** List public Slack channels available for broadcasting */
  availableBroadcastChannels: Array<BroadcastChannelType>;
  calculateCalories: Scalars['Float']['output'];
  calculateDistance: Scalars['Float']['output'];
  challenge?: Maybe<Challenge>;
  challengeByInviteToken?: Maybe<Challenge>;
  /** Get challenge entry fee limits (min/max buy-in). Available to any authenticated user. */
  challengeEntryFeeLimits: ChallengeEntryFeeLimitsType;
  challenges: Array<Challenge>;
  challengesConnection: ChallengeConnection;
  /** Get the active chat integration for an organization */
  chatIntegration?: Maybe<ChatIntegrationType>;
  checkPolicyRequirements: Array<PolicyType>;
  comprehensivePrivacyPolicy?: Maybe<Policy>;
  /** Get the active economy configuration (Admin only) */
  economyConfig: EconomyConfigType;
  event?: Maybe<Event>;
  eventByInviteToken?: Maybe<Event>;
  events: Array<Event>;
  eventsConnection: EventConnection;
  feed: Array<FeedItem>;
  feedback?: Maybe<Feedback>;
  feedbacks: Array<Feedback>;
  getActivityEditPreview: EditActivityPreview;
  getEmailStats: Scalars['String']['output'];
  /** Check if the user's organization has a connected chat integration. Returns true if a CONNECTED integration with a selected channel exists. */
  hasConnectedChatIntegration: Scalars['Boolean']['output'];
  healthDeviceData?: Maybe<HealthDeviceDailyTotal>;
  healthDeviceDataRange: Array<HealthDeviceDailyTotal>;
  hello: Scalars['String']['output'];
  koinsLeaderboard: Array<KoinsLeaderboardRow>;
  latestPolicy?: Maybe<Policy>;
  /** Get details of a single marketplace item */
  marketplaceItem: MarketplaceItemType;
  /** Browse available marketplace reward items */
  marketplaceItems: MarketplaceItemsResponse;
  me: User;
  myDevice?: Maybe<HealthDevice>;
  myDevices: Array<HealthDevice>;
  myFairnessData: MyFairnessData;
  myKoinsBalance: KoinsBalance;
  myKoinsHistory: KoinsLedgerHistoryPage;
  /** Organizations the caller can manage (ORG_ADMIN: org-level admin orgs; ADMIN: all) */
  myManagedOrganizations: Array<Organization>;
  myNotificationPreferences: NotificationPreferenceType;
  /** Get details of a single order */
  myOrder: MarketplaceOrderType;
  /** Get your order history */
  myOrders: MarketplaceOrdersResponse;
  myOrganizations: Array<Organization>;
  myPolicyConsentHistory: PolicyConsentHistoryPage;
  myPolicyConsents: Array<PolicyConsentType>;
  notificationTemplate?: Maybe<NotificationTemplateType>;
  notificationTemplates: Array<NotificationTemplateType>;
  notificationTriggerContracts: Array<TriggerContractType>;
  onboardingContext: OnboardingContext;
  orgReport?: Maybe<OrgReport>;
  /** List engagement reports for an organization, newest first. ORG_ADMIN scoped to their org; ADMIN may query any org. */
  orgReports: Array<OrgReport>;
  organization?: Maybe<Organization>;
  organizationChallenges: OrganizationChallengesResult;
  /** Organization dashboard with aggregated metrics for HR admins */
  organizationDashboard: OrganizationDashboardResponse;
  /** Extended org details for ADMIN drill-down */
  organizationDetailAdmin: OrganizationDetailAdmin;
  organizationEvents: OrganizationEventsResult;
  /** List marketplace items for a specific organization */
  organizationMarketplaceItems: MarketplaceItemsResponse;
  organizationMembers: Array<OrganizationMember>;
  /** Order statistics for a specific organization */
  organizationOrderStats: OrganizationOrderStatsType;
  /** List marketplace orders for a specific organization */
  organizationOrders: MarketplaceOrdersResponse;
  /** Paginated roster entries with enrollment status */
  organizationRoster: OrganizationRosterResult;
  /** Aggregate roster stats for a single organization */
  organizationRosterStats: OrganizationRosterStats;
  organizations: Array<Organization>;
  policies: Array<Policy>;
  policyVersions: Array<Policy>;
  previewEmailTemplate: Scalars['String']['output'];
  previewNotificationTemplate: NotificationPreviewType;
  publicActivities: Array<Activity>;
  /** Get dead-letter queue jobs for a specific queue (ADMIN only) */
  queueDlqJobs: QueueJobsResult;
  /** Get jobs for a specific queue filtered by status (ADMIN only) */
  queueJobs: QueueJobsResult;
  /** Get overview stats for all BullMQ queues (ADMIN only) */
  queueOverview: QueueOverviewType;
  suggestedActivities: Array<Activity>;
  termsOfService?: Maybe<Policy>;
  user?: Maybe<User>;
  userByEmail?: Maybe<User>;
  users: UsersConnection;
  validateActivityCompatibility: Scalars['String']['output'];
  version: Scalars['String']['output'];
};


export type QueryActivitiesArgs = {
  filters?: InputMaybe<ActivityFiltersInput>;
  sort?: InputMaybe<ActivitySortInput>;
};


export type QueryActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityHistoryArgs = {
  input: ActivityHistoryInput;
};


export type QueryActivityStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  granularity?: InputMaybe<StatsGranularity>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivityTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityTypeByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryActivityTypesArgs = {
  filters?: InputMaybe<ActivityTypeFiltersInput>;
  sort?: InputMaybe<ActivityTypeSortInput>;
};


export type QueryAdminExportLeadsArgs = {
  filters?: InputMaybe<LeadFiltersInput>;
};


export type QueryAdminHealthSyncMonitoringArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminLeadDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminLeadStatsArgs = {
  filters?: InputMaybe<LeadFiltersInput>;
};


export type QueryAdminLeadsArgs = {
  filters?: InputMaybe<LeadFiltersInput>;
  pagination: LeadPaginationInput;
};


export type QueryAdminMarketplaceItemsArgs = {
  input?: InputMaybe<MarketplaceItemsFilterInput>;
};


export type QueryAdminNotificationLogMonitoringArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPolicyConsentHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryAdminRecentLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminSearchUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryAdminUserDetailArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminUserLedgerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<KoinsSourceType>;
  userId: Scalars['ID']['input'];
};


export type QueryAllOrdersArgs = {
  input?: InputMaybe<AllOrdersFilterInput>;
};


export type QueryAllOrganizationsArgs = {
  input?: InputMaybe<AllOrganizationsInput>;
};


export type QueryAnalyticsBreakdownArgs = {
  dimension: AnalyticsBreakdownDimension;
  event: Scalars['String']['input'];
  range: AnalyticsDateRangeInput;
};


export type QueryAnalyticsTimeSeriesArgs = {
  event: Scalars['String']['input'];
  granularity?: InputMaybe<AnalyticsGranularity>;
  range: AnalyticsDateRangeInput;
};


export type QueryAnalyticsTopEventsArgs = {
  limit: Scalars['Int']['input'];
  range: AnalyticsDateRangeInput;
};


export type QueryAvailableBroadcastChannelsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryCalculateCaloriesArgs = {
  activityTypeId: Scalars['ID']['input'];
  metrics: Scalars['String']['input'];
  userWeight?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryCalculateDistanceArgs = {
  activityTypeId: Scalars['ID']['input'];
  metrics: Scalars['String']['input'];
};


export type QueryChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChallengeByInviteTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryChallengesArgs = {
  filters?: InputMaybe<ChallengeFiltersInput>;
  sort?: InputMaybe<ChallengeSortInput>;
};


export type QueryChallengesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChallengeFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ChallengeSortInput>;
};


export type QueryChatIntegrationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryComprehensivePrivacyPolicyArgs = {
  locale?: InputMaybe<UserLocale>;
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventByInviteTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  sort?: InputMaybe<EventSortInput>;
};


export type QueryEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<EventFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EventSortInput>;
};


export type QueryFeedArgs = {
  filters?: InputMaybe<FeedFiltersInput>;
};


export type QueryFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbacksArgs = {
  filters?: InputMaybe<FeedbackFiltersInput>;
  sort?: InputMaybe<FeedbackSortInput>;
};


export type QueryGetActivityEditPreviewArgs = {
  input: EditActivityInput;
};


export type QueryGetEmailStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHasConnectedChatIntegrationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryHealthDeviceDataArgs = {
  date: Scalars['DateTime']['input'];
  provider: HealthProvider;
};


export type QueryHealthDeviceDataRangeArgs = {
  endDate: Scalars['DateTime']['input'];
  provider: HealthProvider;
  startDate: Scalars['DateTime']['input'];
};


export type QueryKoinsLeaderboardArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  window: KoinsWindow;
};


export type QueryLatestPolicyArgs = {
  locale?: InputMaybe<UserLocale>;
  type: PolicyType;
};


export type QueryMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMarketplaceItemsArgs = {
  input?: InputMaybe<MarketplaceItemsFilterInput>;
};


export type QueryMyDeviceArgs = {
  provider: HealthProvider;
};


export type QueryMyKoinsHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  window?: InputMaybe<KoinsWindow>;
};


export type QueryMyOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyOrdersArgs = {
  input?: InputMaybe<MyOrdersFilterInput>;
};


export type QueryMyPolicyConsentHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotificationTemplateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type QueryNotificationTemplatesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrgReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrgReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationChallengesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<ChallengeStatus>;
};


export type QueryOrganizationDashboardArgs = {
  organizationId: Scalars['ID']['input'];
  period: DashboardPeriod;
};


export type QueryOrganizationDetailAdminArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<EventStatus>;
};


export type QueryOrganizationMarketplaceItemsArgs = {
  input: OrganizationMarketplaceItemsInput;
};


export type QueryOrganizationMembersArgs = {
  input?: InputMaybe<OrganizationMembersInput>;
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationOrderStatsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationOrdersArgs = {
  input: OrganizationOrdersInput;
};


export type QueryOrganizationRosterArgs = {
  input?: InputMaybe<OrganizationRosterInput>;
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationRosterStatsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  filters?: InputMaybe<OrganizationFiltersInput>;
  sort?: InputMaybe<OrganizationSortInput>;
};


export type QueryPoliciesArgs = {
  includeComprehensive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<UserLocale>;
  type?: InputMaybe<PolicyType>;
};


export type QueryPolicyVersionsArgs = {
  locale?: InputMaybe<UserLocale>;
  type: PolicyType;
};


export type QueryPreviewEmailTemplateArgs = {
  data: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  template: Scalars['String']['input'];
};


export type QueryPreviewNotificationTemplateArgs = {
  input: PreviewNotificationTemplateInput;
};


export type QueryPublicActivitiesArgs = {
  filters?: InputMaybe<ActivityFiltersInput>;
  sort?: InputMaybe<ActivitySortInput>;
};


export type QueryQueueDlqJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  queueName: Scalars['String']['input'];
};


export type QueryQueueJobsArgs = {
  input: QueueJobsInput;
};


export type QuerySuggestedActivitiesArgs = {
  intensity?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  weather?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTermsOfServiceArgs = {
  locale?: InputMaybe<UserLocale>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UserSortInput>;
};


export type QueryValidateActivityCompatibilityArgs = {
  activityTypeId: Scalars['ID']['input'];
  intensity?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  weather?: InputMaybe<Scalars['String']['input']>;
};

export enum QueueJobStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Waiting = 'WAITING'
}

/** Individual job details */
export type QueueJobType = {
  __typename?: 'QueueJobType';
  attemptsMade: Scalars['Int']['output'];
  data: Scalars['String']['output'];
  delay: Scalars['Int']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  finishedOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  maxAttempts: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  processedOn?: Maybe<Scalars['DateTime']['output']>;
  progress: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type QueueJobsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  queueName: Scalars['String']['input'];
  status: QueueJobStatus;
};

/** Paginated job list result */
export type QueueJobsResult = {
  __typename?: 'QueueJobsResult';
  jobs: Array<QueueJobType>;
  total: Scalars['Int']['output'];
};

/** Overview of all queues */
export type QueueOverviewType = {
  __typename?: 'QueueOverviewType';
  dlqs?: Maybe<Array<QueueStatsType>>;
  queues: Array<QueueStatsType>;
  totalActive: Scalars['Int']['output'];
  totalFailed: Scalars['Int']['output'];
  totalWaiting: Scalars['Int']['output'];
};

/** Stats for a single BullMQ queue */
export type QueueStatsType = {
  __typename?: 'QueueStatsType';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  delayed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  isPaused: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paused: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type RecordAnalyticsEventsInput = {
  /** App version, MAJOR.MINOR.PATCH. */
  appVersion: Scalars['String']['input'];
  /** Client-generated UUID for idempotent ingestion of this batch. */
  clientBatchId?: InputMaybe<Scalars['String']['input']>;
  events: Array<AnalyticsEventInput>;
  /** UI locale; en | de are kept, anything else is stored as 'unknown'. */
  locale: Scalars['String']['input'];
  /** Emitting platform: ios | android. */
  platform: Scalars['String']['input'];
};

export type RecordAnalyticsResult = {
  __typename?: 'RecordAnalyticsResult';
  /** Events accepted and queued for counting. */
  accepted: Scalars['Int']['output'];
  /** Events dropped (unknown event, unusable platform, or consent withdrawn). */
  dropped: Scalars['Int']['output'];
};

export type RecurrenceConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  intervalUnit?: InputMaybe<RecurrenceUnit>;
  intervalValue?: InputMaybe<Scalars['Int']['input']>;
};

export type RecurrenceConfigType = {
  __typename?: 'RecurrenceConfigType';
  enabled: Scalars['Boolean']['output'];
  intervalUnit: RecurrenceUnit;
  intervalValue: Scalars['Int']['output'];
};

/** Unit for recurrence interval (days, weeks, months) */
export enum RecurrenceUnit {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type RegisterInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  magicLinkToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  policyConsents?: InputMaybe<Array<PolicyConsentInput>>;
};

/** Language the PDF report is rendered in. */
export enum ReportLocale {
  De = 'DE',
  En = 'EN',
  Tr = 'TR'
}

/** Reporting period coverage (monthly, quarterly, custom range). */
export enum ReportPeriodType {
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

/** Lifecycle of a generated engagement report — drives the admin-portal UI. */
export enum ReportStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Pending = 'PENDING'
}

export type ReportTrends = {
  __typename?: 'ReportTrends';
  weeklyActiveUsers: Array<WeeklyDataPoint>;
  weeklyKoinsEarned: Array<WeeklyDataPoint>;
  weeklyRedemptions: Array<WeeklyDataPoint>;
  weeklySteps: Array<WeeklyDataPoint>;
};

export type RevokePolicyInput = {
  type: PolicyType;
};

export type RevokePolicyResponse = {
  __typename?: 'RevokePolicyResponse';
  affectedDataCount?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  revokedPolicyType: PolicyType;
  success: Scalars['Boolean']['output'];
};

/** Enrollment status of a roster entry: ACTIVE (user linked), PENDING (invite sent), NOT_INVITED */
export enum RosterEnrollmentStatus {
  Active = 'ACTIVE',
  NotInvited = 'NOT_INVITED',
  Pending = 'PENDING'
}

export type SaveNotificationTemplateInput = {
  body: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Current seat usage and capacity for an organization */
export type SeatUsage = {
  __typename?: 'SeatUsage';
  /** Seat limit (null = unlimited) */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Usage percentage (null if unlimited) */
  percentage?: Maybe<Scalars['Float']['output']>;
  status: SeatUsageStatus;
  used: Scalars['Int']['output'];
};

/** Status of seat capacity for an organization */
export enum SeatUsageStatus {
  Critical = 'CRITICAL',
  Full = 'FULL',
  Ok = 'OK',
  Unlimited = 'UNLIMITED',
  Warning = 'WARNING'
}

/** Input for selecting a broadcast channel */
export type SelectBroadcastChannelInput = {
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
};

export type SendAdminNotificationInput = {
  body: Scalars['String']['input'];
  /** JSON string for deep link payload */
  data?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: NotificationType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of sending roster invitations */
export type SendRosterInvitesReport = {
  __typename?: 'SendRosterInvitesReport';
  alreadyRegistered: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type SetGoalsInput = {
  goals: Array<GoalInput>;
};

/** Sort order (ascending or descending) */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpendKoinsInput = {
  amount: Scalars['Int']['input'];
  marketplaceItemId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  /** Client-provided idempotency key for safe retries. If omitted, a deterministic key is generated from userId + sourceId + amount. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** Time granularity for historical activity stats */
export enum StatsGranularity {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type StatusCount = {
  __typename?: 'StatusCount';
  count: Scalars['Int']['output'];
  status: LeadStatus;
};

export type StepTierType = {
  __typename?: 'StepTierType';
  fromSteps: Scalars['Int']['output'];
  koinsPerThousand: Scalars['Float']['output'];
  toSteps: Scalars['Int']['output'];
};

/** Surface types for activities */
export enum SurfaceType {
  Concrete = 'CONCRETE',
  Grass = 'GRASS',
  Gravel = 'GRAVEL',
  Ice = 'ICE',
  Indoor = 'INDOOR',
  OpenWater = 'OPEN_WATER',
  Outdoor = 'OUTDOOR',
  Pool = 'POOL',
  Road = 'ROAD',
  Sand = 'SAND',
  Snow = 'SNOW',
  Track = 'TRACK',
  Trail = 'TRAIL',
  Treadmill = 'TREADMILL'
}

/** Input for suspending an organization */
export type SuspendOrganizationInput = {
  organizationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Health status of a device's background sync */
export enum SyncHealthStatus {
  Critical = 'CRITICAL',
  Disconnected = 'DISCONNECTED',
  Healthy = 'HEALTHY',
  NeverSynced = 'NEVER_SYNCED',
  Warning = 'WARNING'
}

export type SyncHealthTelemetryInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  deletedUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  inserts?: InputMaybe<Array<HealthTelemetrySampleInput>>;
  provider: HealthProvider;
};

export type SyncHealthTelemetryPayload = {
  __typename?: 'SyncHealthTelemetryPayload';
  acceptedDeletes: Scalars['Float']['output'];
  acceptedInserts: Scalars['Float']['output'];
  processedAt: Scalars['DateTime']['output'];
  queuedPartitions: Scalars['Float']['output'];
  storedCursor?: Maybe<Scalars['String']['output']>;
};

export type TemplateVariableType = {
  __typename?: 'TemplateVariableType';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type TierCount = {
  __typename?: 'TierCount';
  count: Scalars['Int']['output'];
  tier: LeadTier;
};

export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  period: Scalars['String']['output'];
  periodEnd: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  totalActivities: Scalars['Int']['output'];
  totalCalories: Scalars['Float']['output'];
  totalDistance: Scalars['Float']['output'];
  totalDuration: Scalars['Float']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type TriggerContractType = {
  __typename?: 'TriggerContractType';
  description: Scalars['String']['output'];
  notificationType: NotificationType;
  providedVariables: Array<TriggerContractVariableType>;
  templateName: Scalars['String']['output'];
};

export type TriggerContractVariableType = {
  __typename?: 'TriggerContractVariableType';
  description: Scalars['String']['output'];
  example: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateActivityInput = {
  activityTypeId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** User asserts device already tracked this activity */
  deviceTracked?: InputMaybe<Scalars['Boolean']['input']>;
  difficultyLevel?: InputMaybe<DifficultyLevel>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipment?: InputMaybe<ActivityEquipmentInput>;
  intensityLevel?: InputMaybe<IntensityLevel>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<Array<ActivityMetricInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<ActivityRouteInput>;
  status?: InputMaybe<ActivityStatus>;
  surfaceType?: InputMaybe<SurfaceType>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  weather?: InputMaybe<ActivityWeatherInput>;
};

export type UpdateActivityTypeInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  conversionRules?: InputMaybe<Array<ConversionRuleInput>>;
  defaultCaloriesPerHour?: InputMaybe<Scalars['Float']['input']>;
  defaultMETValue?: InputMaybe<Scalars['Float']['input']>;
  defaultStepCadence?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metricFields?: InputMaybe<Array<MetricFieldInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for updating broadcast notification settings */
export type UpdateBroadcastSettingsInput = {
  challengeAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  leaderboardDropsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rewardShoutoutsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChallengeInput = {
  accessibility?: InputMaybe<ChallengeAccessibility>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  entryFee?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<RecurrenceConfigInput>;
  rewards?: InputMaybe<Array<ChallengeRewardInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ChallengeStatus>;
};

export type UpdateEconomyConfigInput = {
  activityCooldownMinutes?: InputMaybe<Scalars['Int']['input']>;
  anomalyRollingMultiplier?: InputMaybe<Scalars['Float']['input']>;
  challengeHouseBurnPercentage?: InputMaybe<Scalars['Float']['input']>;
  challengeMaxBuyIn?: InputMaybe<Scalars['Int']['input']>;
  challengeMinBuyIn?: InputMaybe<Scalars['Int']['input']>;
  challengeMinParticipantsForPaid?: InputMaybe<Scalars['Int']['input']>;
  challengePrizePoolPercentage?: InputMaybe<Scalars['Float']['input']>;
  challengeTwoPlayerWinnerPct?: InputMaybe<Scalars['Float']['input']>;
  dailyExerciseKoinsCap?: InputMaybe<Scalars['Int']['input']>;
  dailyStepKoinsCap?: InputMaybe<Scalars['Int']['input']>;
  exerciseScaleFactor?: InputMaybe<Scalars['Float']['input']>;
  fairnessAgeBaseline?: InputMaybe<Scalars['Int']['input']>;
  fairnessAgeCoefficient?: InputMaybe<Scalars['Float']['input']>;
  fairnessBMIBaseline?: InputMaybe<Scalars['Int']['input']>;
  fairnessBMICoefficient?: InputMaybe<Scalars['Float']['input']>;
  fairnessMaxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  fallbackMETValue?: InputMaybe<Scalars['Float']['input']>;
  manualSourcePenalty?: InputMaybe<Scalars['Float']['input']>;
  maxManualCaloriesPerActivity?: InputMaybe<Scalars['Int']['input']>;
  maxManualDistanceKmPerActivity?: InputMaybe<Scalars['Int']['input']>;
  maxManualStepsPerActivity?: InputMaybe<Scalars['Int']['input']>;
  maxStepsPerMinute?: InputMaybe<Scalars['Int']['input']>;
  onboardingBonusAmount?: InputMaybe<Scalars['Int']['input']>;
  referencePricePerTenEuro?: InputMaybe<Scalars['Int']['input']>;
  streakMinActivityMinutesForQualifyingDay?: InputMaybe<Scalars['Int']['input']>;
  streakMinStepsForQualifyingDay?: InputMaybe<Scalars['Int']['input']>;
  streakRequiredDays?: InputMaybe<Scalars['Int']['input']>;
  streakRewardKoins?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEventInput = {
  accessibility?: InputMaybe<EventAccessibility>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<EventLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<RecurrenceConfigInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EventStatus>;
};

export type UpdateGoogleSsoInput = {
  allowJIT?: InputMaybe<Scalars['Boolean']['input']>;
  hostedDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Update lead fields */
export type UpdateLeadInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextFollowUpAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<CompanySize>;
  tier?: InputMaybe<LeadTier>;
};

/** Update lead status with state machine validation */
export type UpdateLeadStatusInput = {
  leadId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: LeadStatus;
};

/** Input for updating an existing marketplace item */
export type UpdateMarketplaceItemInput = {
  /** Enable monthly auto-refill */
  autoRefill?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<MarketplaceCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentInstructions?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  koinsPrice?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Day of month (1-28) to refill */
  refillDay?: InputMaybe<Scalars['Int']['input']>;
  /** Quantity to restock monthly */
  refillQuantity?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Set to null/omit for unlimited */
  totalInventory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMicrosoftSsoInput = {
  allowJIT?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationPreferencesInput = {
  disabledTypes?: InputMaybe<Array<NotificationType>>;
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** Plan tier (ADMIN only) */
  tier?: InputMaybe<OrganizationTier>;
  type?: InputMaybe<OrganizationType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationSsoInput = {
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enforced?: InputMaybe<Scalars['Boolean']['input']>;
  google?: InputMaybe<UpdateGoogleSsoInput>;
  microsoft?: InputMaybe<UpdateMicrosoftSsoInput>;
  organizationId: Scalars['String']['input'];
};

/** Input for updating an organization's tier and seat limit */
export type UpdateOrganizationTierInput = {
  /** Custom seat limit override (null = use tier default) */
  maxUsers?: InputMaybe<Scalars['Int']['input']>;
  tier: OrganizationTier;
};

/** Result of updating an organization's tier */
export type UpdateOrganizationTierResult = {
  __typename?: 'UpdateOrganizationTierResult';
  organization: Organization;
  /** Number of users who can now be enrolled after capacity increase */
  pendingEnrollmentCount: Scalars['Int']['output'];
  seatUsage: SeatUsage;
};

export type UploadConfirmationResponse = {
  __typename?: 'UploadConfirmationResponse';
  cdnUrl: Scalars['String']['output'];
  contentLength: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
};

/** The purpose/category of the file upload */
export enum UploadPurpose {
  Avatar = 'AVATAR',
  Challenge = 'CHALLENGE',
  Event = 'EVENT',
  Marketplace = 'MARKETPLACE',
  Organization = 'ORGANIZATION'
}

export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  accountStatus?: Maybe<AccountStatus>;
  age?: Maybe<Scalars['Float']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  bmi?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use organizations / organizationDetails field instead. This field will be removed in a future release. */
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentStreakDays: Scalars['Int']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deletionRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  deletionScheduledFor?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  goals?: Maybe<Array<Goal>>;
  hasPassword: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDeletionPending: Scalars['Boolean']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  koinBalance: Scalars['Int']['output'];
  lastLoginAt: Scalars['DateTime']['output'];
  lastLoginMethod?: Maybe<AuthMethod>;
  lastName: Scalars['String']['output'];
  lastStreakQualifyingDate?: Maybe<Scalars['String']['output']>;
  leaderboardVisibility: LeaderboardVisibility;
  lifetimeKoins: Scalars['Int']['output'];
  locale: UserLocale;
  magicLinkLoginCount: Scalars['Float']['output'];
  onboardingStep: Scalars['Int']['output'];
  organizationDetails?: Maybe<Array<Organization>>;
  organizations?: Maybe<Array<Scalars['String']['output']>>;
  passwordLoginCount: Scalars['Float']['output'];
  passwordUpdatedAt: Scalars['DateTime']['output'];
  preferredAuthMethod: AuthMethod;
  role: UserRole;
  streakFreezesAvailable: Scalars['Int']['output'];
  tier: UserTier;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Preferred display locale for UI, push notifications, and email. */
export enum UserLocale {
  De = 'DE',
  En = 'EN',
  Tr = 'TR'
}

export enum UserRole {
  Admin = 'ADMIN',
  Moderator = 'MODERATOR',
  OrgAdmin = 'ORG_ADMIN',
  User = 'USER'
}

/** Fields available for sorting users */
export enum UserSortField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Role = 'ROLE'
}

export type UserSortInput = {
  field?: InputMaybe<UserSortField>;
  order?: InputMaybe<SortOrder>;
};

export enum UserTier {
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Premium = 'PREMIUM'
}

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ValidationResultType = {
  __typename?: 'ValidationResultType';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type VerifyMagicLinkInput = {
  policyConsents?: InputMaybe<Array<PolicyConsentInput>>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Weather conditions for activities */
export enum WeatherCondition {
  Cloudy = 'CLOUDY',
  Cold = 'COLD',
  Drizzle = 'DRIZZLE',
  Foggy = 'FOGGY',
  Hot = 'HOT',
  Overcast = 'OVERCAST',
  PartlyCloudy = 'PARTLY_CLOUDY',
  Rainy = 'RAINY',
  Snowy = 'SNOWY',
  Stormy = 'STORMY',
  Sunny = 'SUNNY',
  Windy = 'WINDY'
}

export type WeeklyDataPoint = {
  __typename?: 'WeeklyDataPoint';
  isoWeek: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AnalyticsTimeSeriesQueryVariables = Exact<{
  event: Scalars['String']['input'];
  range: AnalyticsDateRangeInput;
  granularity?: InputMaybe<AnalyticsGranularity>;
}>;


export type AnalyticsTimeSeriesQuery = { __typename?: 'Query', analyticsTimeSeries: Array<{ __typename?: 'AnalyticsTimeSeriesPoint', period: string, periodEnd: string, count?: number | null, _suppressed?: boolean | null }> };

export type AnalyticsBreakdownQueryVariables = Exact<{
  event: Scalars['String']['input'];
  range: AnalyticsDateRangeInput;
  dimension: AnalyticsBreakdownDimension;
}>;


export type AnalyticsBreakdownQuery = { __typename?: 'Query', analyticsBreakdown: Array<{ __typename?: 'AnalyticsBreakdownPoint', key: string, count?: number | null, _suppressed?: boolean | null }> };

export type AnalyticsTopEventsQueryVariables = Exact<{
  range: AnalyticsDateRangeInput;
  limit: Scalars['Int']['input'];
}>;


export type AnalyticsTopEventsQuery = { __typename?: 'Query', analyticsTopEvents: Array<{ __typename?: 'AnalyticsTopEventPoint', event: string, count?: number | null, _suppressed?: boolean | null }> };

export type AnalyticsEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsEventsQuery = { __typename?: 'Query', analyticsEvents: Array<string> };

export type MyManagedOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyManagedOrganizationsQuery = { __typename?: 'Query', myManagedOrganizations: Array<{ __typename?: 'Organization', _id: string, name: string, type: OrganizationType, picture?: string | null, memberCount: number }> };

export type OrgReportListItemFragment = { __typename?: 'OrgReport', _id: string, organizationId: string, periodType: ReportPeriodType, periodStart: string, periodEnd: string, periodLabel: string, status: ReportStatus, locale: ReportLocale, errorMessage?: string | null, generatedAt?: string | null, expiresAt: string, createdAt: string };

export type OrgReportFullFragment = { __typename?: 'OrgReport', downloadUrl?: string | null, _id: string, organizationId: string, periodType: ReportPeriodType, periodStart: string, periodEnd: string, periodLabel: string, status: ReportStatus, locale: ReportLocale, errorMessage?: string | null, generatedAt?: string | null, expiresAt: string, createdAt: string, metrics?: { __typename?: 'OrgReportMetricsType', totalActiveMembers: number, totalInvitedMembers: number, adoptionRate: number, activeEmployeeRate: number, dauMauRatio: number, streakAchievementRate: number, newActivationsInPeriod: number, totalSteps: number, totalDistanceMeters: number, totalCalories: number, totalExerciseMinutes: number, avgDailyStepsPerActiveEmployee: number, manualActivityCount: number, challengesCompleted: number, challengeParticipationRate: number, eventsHeld: number, eventAttendanceRate: number, totalKoinsEarned: number, totalKoinsSpent: number, koinsInCirculation: number, estimatedRewardValueEur: number, budgetUtilizationRate: number, marketplaceRedemptions: number, activityConsentRate: number, healthConsentRate: number, suppressedDueToLowMembership: boolean, topActivityTypes: Array<{ __typename?: 'ActivityTypeCount', activityType: string, count: number }>, marketplaceRedemptionsByCategory: Array<{ __typename?: 'CategoryCount', category: string, count: number, koinsSpent: number }>, trends: { __typename?: 'ReportTrends', weeklyActiveUsers: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }>, weeklySteps: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }>, weeklyKoinsEarned: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }>, weeklyRedemptions: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }> }, previousPeriod: { __typename?: 'PreviousPeriodSnapshot', activeEmployeeRate: number, totalSteps: number, totalKoinsEarned: number, challengeParticipationRate: number, marketplaceRedemptions: number } } | null };

export type OrgReportsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrgReportsQuery = { __typename?: 'Query', orgReports: Array<{ __typename?: 'OrgReport', _id: string, organizationId: string, periodType: ReportPeriodType, periodStart: string, periodEnd: string, periodLabel: string, status: ReportStatus, locale: ReportLocale, errorMessage?: string | null, generatedAt?: string | null, expiresAt: string, createdAt: string }> };

export type OrgReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrgReportQuery = { __typename?: 'Query', orgReport?: { __typename?: 'OrgReport', downloadUrl?: string | null, _id: string, organizationId: string, periodType: ReportPeriodType, periodStart: string, periodEnd: string, periodLabel: string, status: ReportStatus, locale: ReportLocale, errorMessage?: string | null, generatedAt?: string | null, expiresAt: string, createdAt: string, metrics?: { __typename?: 'OrgReportMetricsType', totalActiveMembers: number, totalInvitedMembers: number, adoptionRate: number, activeEmployeeRate: number, dauMauRatio: number, streakAchievementRate: number, newActivationsInPeriod: number, totalSteps: number, totalDistanceMeters: number, totalCalories: number, totalExerciseMinutes: number, avgDailyStepsPerActiveEmployee: number, manualActivityCount: number, challengesCompleted: number, challengeParticipationRate: number, eventsHeld: number, eventAttendanceRate: number, totalKoinsEarned: number, totalKoinsSpent: number, koinsInCirculation: number, estimatedRewardValueEur: number, budgetUtilizationRate: number, marketplaceRedemptions: number, activityConsentRate: number, healthConsentRate: number, suppressedDueToLowMembership: boolean, topActivityTypes: Array<{ __typename?: 'ActivityTypeCount', activityType: string, count: number }>, marketplaceRedemptionsByCategory: Array<{ __typename?: 'CategoryCount', category: string, count: number, koinsSpent: number }>, trends: { __typename?: 'ReportTrends', weeklyActiveUsers: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }>, weeklySteps: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }>, weeklyKoinsEarned: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }>, weeklyRedemptions: Array<{ __typename?: 'WeeklyDataPoint', isoWeek: string, value: number }> }, previousPeriod: { __typename?: 'PreviousPeriodSnapshot', activeEmployeeRate: number, totalSteps: number, totalKoinsEarned: number, challengeParticipationRate: number, marketplaceRedemptions: number } } | null } | null };

export type GenerateOrgReportMutationVariables = Exact<{
  input: GenerateOrgReportInput;
}>;


export type GenerateOrgReportMutation = { __typename?: 'Mutation', generateOrgReport: { __typename?: 'OrgReport', _id: string, organizationId: string, periodType: ReportPeriodType, periodStart: string, periodEnd: string, periodLabel: string, status: ReportStatus, locale: ReportLocale, errorMessage?: string | null, generatedAt?: string | null, expiresAt: string, createdAt: string } };

export type RegenerateOrgReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type RegenerateOrgReportMutation = { __typename?: 'Mutation', regenerateOrgReport: { __typename?: 'OrgReport', _id: string, organizationId: string, periodType: ReportPeriodType, periodStart: string, periodEnd: string, periodLabel: string, status: ReportStatus, locale: ReportLocale, errorMessage?: string | null, generatedAt?: string | null, expiresAt: string, createdAt: string } };

export type DeleteOrgReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type DeleteOrgReportMutation = { __typename?: 'Mutation', deleteOrgReport: { __typename?: 'OrgReport', _id: string, status: ReportStatus } };

export type OrganizationRosterQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input?: InputMaybe<OrganizationRosterInput>;
}>;


export type OrganizationRosterQuery = { __typename?: 'Query', organizationRoster: { __typename?: 'OrganizationRosterResult', total: number, hasMore: boolean, items: Array<{ __typename?: 'OrganizationRosterEntry', _id: string, organizationId: string, workEmail: string, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, department?: string | null, employeeStatus?: string | null, employeeId?: string | null, enrollmentStatus: RosterEnrollmentStatus, createdAt: string, updatedAt: string }> } };

export type OrganizationRosterStatsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationRosterStatsQuery = { __typename?: 'Query', organizationRosterStats: { __typename?: 'OrganizationRosterStats', totalEntries: number, activeUsers: number, pendingInvites: number, notInvited: number } };

export type BulkImportUsersMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  input?: InputMaybe<BulkImportUsersInput>;
}>;


export type BulkImportUsersMutation = { __typename?: 'Mutation', bulkImportUsers: { __typename?: 'BulkImportUsersReport', successCount: number, skippedCount: number, errorCount: number, warnings: Array<string>, errors: Array<{ __typename?: 'BulkImportRowError', row: number, error: string }> } };

export type SendRosterInvitesMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SendRosterInvitesMutation = { __typename?: 'Mutation', sendRosterInvites: { __typename?: 'SendRosterInvitesReport', sent: number, alreadyRegistered: number, failed: number } };

export type OrganizationSsoFieldsFragment = { __typename?: 'OrganizationSSOConfigType', enabled: boolean, enforced: boolean, emailDomains: Array<string>, domainsVerifiedAt?: string | null, updatedAt: string, google?: { __typename?: 'OrganizationSSOGoogleConfigType', hostedDomain: string, allowJIT: boolean } | null, microsoft?: { __typename?: 'OrganizationSSOMicrosoftConfigType', tenantId: string, allowJIT: boolean } | null };

export type OrganizationSsoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationSsoQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', _id: string, name: string, sso?: { __typename?: 'OrganizationSSOConfigType', enabled: boolean, enforced: boolean, emailDomains: Array<string>, domainsVerifiedAt?: string | null, updatedAt: string, google?: { __typename?: 'OrganizationSSOGoogleConfigType', hostedDomain: string, allowJIT: boolean } | null, microsoft?: { __typename?: 'OrganizationSSOMicrosoftConfigType', tenantId: string, allowJIT: boolean } | null } | null } | null };

export type UpdateOrganizationSsoMutationVariables = Exact<{
  input: UpdateOrganizationSsoInput;
}>;


export type UpdateOrganizationSsoMutation = { __typename?: 'Mutation', updateOrganizationSSO: { __typename?: 'Organization', _id: string, sso?: { __typename?: 'OrganizationSSOConfigType', enabled: boolean, enforced: boolean, emailDomains: Array<string>, domainsVerifiedAt?: string | null, updatedAt: string, google?: { __typename?: 'OrganizationSSOGoogleConfigType', hostedDomain: string, allowJIT: boolean } | null, microsoft?: { __typename?: 'OrganizationSSOMicrosoftConfigType', tenantId: string, allowJIT: boolean } | null } | null } };

export const OrgReportListItemFragmentDoc = gql`
    fragment OrgReportListItem on OrgReport {
  _id
  organizationId
  periodType
  periodStart
  periodEnd
  periodLabel
  status
  locale
  errorMessage
  generatedAt
  expiresAt
  createdAt
}
    `;
export const OrgReportFullFragmentDoc = gql`
    fragment OrgReportFull on OrgReport {
  ...OrgReportListItem
  downloadUrl
  metrics {
    totalActiveMembers
    totalInvitedMembers
    adoptionRate
    activeEmployeeRate
    dauMauRatio
    streakAchievementRate
    newActivationsInPeriod
    totalSteps
    totalDistanceMeters
    totalCalories
    totalExerciseMinutes
    avgDailyStepsPerActiveEmployee
    manualActivityCount
    topActivityTypes {
      activityType
      count
    }
    challengesCompleted
    challengeParticipationRate
    eventsHeld
    eventAttendanceRate
    totalKoinsEarned
    totalKoinsSpent
    koinsInCirculation
    estimatedRewardValueEur
    budgetUtilizationRate
    marketplaceRedemptions
    marketplaceRedemptionsByCategory {
      category
      count
      koinsSpent
    }
    trends {
      weeklyActiveUsers {
        isoWeek
        value
      }
      weeklySteps {
        isoWeek
        value
      }
      weeklyKoinsEarned {
        isoWeek
        value
      }
      weeklyRedemptions {
        isoWeek
        value
      }
    }
    activityConsentRate
    healthConsentRate
    previousPeriod {
      activeEmployeeRate
      totalSteps
      totalKoinsEarned
      challengeParticipationRate
      marketplaceRedemptions
    }
    suppressedDueToLowMembership
  }
}
    ${OrgReportListItemFragmentDoc}`;
export const OrganizationSsoFieldsFragmentDoc = gql`
    fragment OrganizationSSOFields on OrganizationSSOConfigType {
  enabled
  enforced
  emailDomains
  domainsVerifiedAt
  updatedAt
  google {
    hostedDomain
    allowJIT
  }
  microsoft {
    tenantId
    allowJIT
  }
}
    `;
export const AnalyticsTimeSeriesDocument = gql`
    query AnalyticsTimeSeries($event: String!, $range: AnalyticsDateRangeInput!, $granularity: AnalyticsGranularity) {
  analyticsTimeSeries(event: $event, range: $range, granularity: $granularity) {
    period
    periodEnd
    count
    _suppressed
  }
}
    `;

/**
 * __useAnalyticsTimeSeriesQuery__
 *
 * To run a query within a React component, call `useAnalyticsTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsTimeSeriesQuery({
 *   variables: {
 *      event: // value for 'event'
 *      range: // value for 'range'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useAnalyticsTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables> & ({ variables: AnalyticsTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>(AnalyticsTimeSeriesDocument, options);
      }
export function useAnalyticsTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>(AnalyticsTimeSeriesDocument, options);
        }
// @ts-ignore
export function useAnalyticsTimeSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>;
export function useAnalyticsTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsTimeSeriesQuery | undefined, AnalyticsTimeSeriesQueryVariables>;
export function useAnalyticsTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>(AnalyticsTimeSeriesDocument, options);
        }
export type AnalyticsTimeSeriesQueryHookResult = ReturnType<typeof useAnalyticsTimeSeriesQuery>;
export type AnalyticsTimeSeriesLazyQueryHookResult = ReturnType<typeof useAnalyticsTimeSeriesLazyQuery>;
export type AnalyticsTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useAnalyticsTimeSeriesSuspenseQuery>;
export type AnalyticsTimeSeriesQueryResult = Apollo.QueryResult<AnalyticsTimeSeriesQuery, AnalyticsTimeSeriesQueryVariables>;
export const AnalyticsBreakdownDocument = gql`
    query AnalyticsBreakdown($event: String!, $range: AnalyticsDateRangeInput!, $dimension: AnalyticsBreakdownDimension!) {
  analyticsBreakdown(event: $event, range: $range, dimension: $dimension) {
    key
    count
    _suppressed
  }
}
    `;

/**
 * __useAnalyticsBreakdownQuery__
 *
 * To run a query within a React component, call `useAnalyticsBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsBreakdownQuery({
 *   variables: {
 *      event: // value for 'event'
 *      range: // value for 'range'
 *      dimension: // value for 'dimension'
 *   },
 * });
 */
export function useAnalyticsBreakdownQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables> & ({ variables: AnalyticsBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>(AnalyticsBreakdownDocument, options);
      }
export function useAnalyticsBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>(AnalyticsBreakdownDocument, options);
        }
// @ts-ignore
export function useAnalyticsBreakdownSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>;
export function useAnalyticsBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsBreakdownQuery | undefined, AnalyticsBreakdownQueryVariables>;
export function useAnalyticsBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>(AnalyticsBreakdownDocument, options);
        }
export type AnalyticsBreakdownQueryHookResult = ReturnType<typeof useAnalyticsBreakdownQuery>;
export type AnalyticsBreakdownLazyQueryHookResult = ReturnType<typeof useAnalyticsBreakdownLazyQuery>;
export type AnalyticsBreakdownSuspenseQueryHookResult = ReturnType<typeof useAnalyticsBreakdownSuspenseQuery>;
export type AnalyticsBreakdownQueryResult = Apollo.QueryResult<AnalyticsBreakdownQuery, AnalyticsBreakdownQueryVariables>;
export const AnalyticsTopEventsDocument = gql`
    query AnalyticsTopEvents($range: AnalyticsDateRangeInput!, $limit: Int!) {
  analyticsTopEvents(range: $range, limit: $limit) {
    event
    count
    _suppressed
  }
}
    `;

/**
 * __useAnalyticsTopEventsQuery__
 *
 * To run a query within a React component, call `useAnalyticsTopEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsTopEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsTopEventsQuery({
 *   variables: {
 *      range: // value for 'range'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAnalyticsTopEventsQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables> & ({ variables: AnalyticsTopEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>(AnalyticsTopEventsDocument, options);
      }
export function useAnalyticsTopEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>(AnalyticsTopEventsDocument, options);
        }
// @ts-ignore
export function useAnalyticsTopEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>;
export function useAnalyticsTopEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsTopEventsQuery | undefined, AnalyticsTopEventsQueryVariables>;
export function useAnalyticsTopEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>(AnalyticsTopEventsDocument, options);
        }
export type AnalyticsTopEventsQueryHookResult = ReturnType<typeof useAnalyticsTopEventsQuery>;
export type AnalyticsTopEventsLazyQueryHookResult = ReturnType<typeof useAnalyticsTopEventsLazyQuery>;
export type AnalyticsTopEventsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsTopEventsSuspenseQuery>;
export type AnalyticsTopEventsQueryResult = Apollo.QueryResult<AnalyticsTopEventsQuery, AnalyticsTopEventsQueryVariables>;
export const AnalyticsEventsDocument = gql`
    query AnalyticsEvents {
  analyticsEvents
}
    `;

/**
 * __useAnalyticsEventsQuery__
 *
 * To run a query within a React component, call `useAnalyticsEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsEventsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>(AnalyticsEventsDocument, options);
      }
export function useAnalyticsEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>(AnalyticsEventsDocument, options);
        }
// @ts-ignore
export function useAnalyticsEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>;
export function useAnalyticsEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsEventsQuery | undefined, AnalyticsEventsQueryVariables>;
export function useAnalyticsEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>(AnalyticsEventsDocument, options);
        }
export type AnalyticsEventsQueryHookResult = ReturnType<typeof useAnalyticsEventsQuery>;
export type AnalyticsEventsLazyQueryHookResult = ReturnType<typeof useAnalyticsEventsLazyQuery>;
export type AnalyticsEventsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsEventsSuspenseQuery>;
export type AnalyticsEventsQueryResult = Apollo.QueryResult<AnalyticsEventsQuery, AnalyticsEventsQueryVariables>;
export const MyManagedOrganizationsDocument = gql`
    query MyManagedOrganizations {
  myManagedOrganizations {
    _id
    name
    type
    picture
    memberCount
  }
}
    `;

/**
 * __useMyManagedOrganizationsQuery__
 *
 * To run a query within a React component, call `useMyManagedOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyManagedOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyManagedOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyManagedOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>(MyManagedOrganizationsDocument, options);
      }
export function useMyManagedOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>(MyManagedOrganizationsDocument, options);
        }
// @ts-ignore
export function useMyManagedOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>;
export function useMyManagedOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<MyManagedOrganizationsQuery | undefined, MyManagedOrganizationsQueryVariables>;
export function useMyManagedOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>(MyManagedOrganizationsDocument, options);
        }
export type MyManagedOrganizationsQueryHookResult = ReturnType<typeof useMyManagedOrganizationsQuery>;
export type MyManagedOrganizationsLazyQueryHookResult = ReturnType<typeof useMyManagedOrganizationsLazyQuery>;
export type MyManagedOrganizationsSuspenseQueryHookResult = ReturnType<typeof useMyManagedOrganizationsSuspenseQuery>;
export type MyManagedOrganizationsQueryResult = Apollo.QueryResult<MyManagedOrganizationsQuery, MyManagedOrganizationsQueryVariables>;
export const OrgReportsDocument = gql`
    query OrgReports($organizationId: ID!, $limit: Int = 12, $skip: Int = 0) {
  orgReports(organizationId: $organizationId, limit: $limit, skip: $skip) {
    ...OrgReportListItem
  }
}
    ${OrgReportListItemFragmentDoc}`;

/**
 * __useOrgReportsQuery__
 *
 * To run a query within a React component, call `useOrgReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgReportsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useOrgReportsQuery(baseOptions: Apollo.QueryHookOptions<OrgReportsQuery, OrgReportsQueryVariables> & ({ variables: OrgReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgReportsQuery, OrgReportsQueryVariables>(OrgReportsDocument, options);
      }
export function useOrgReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgReportsQuery, OrgReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgReportsQuery, OrgReportsQueryVariables>(OrgReportsDocument, options);
        }
// @ts-ignore
export function useOrgReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgReportsQuery, OrgReportsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgReportsQuery, OrgReportsQueryVariables>;
export function useOrgReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgReportsQuery, OrgReportsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgReportsQuery | undefined, OrgReportsQueryVariables>;
export function useOrgReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgReportsQuery, OrgReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgReportsQuery, OrgReportsQueryVariables>(OrgReportsDocument, options);
        }
export type OrgReportsQueryHookResult = ReturnType<typeof useOrgReportsQuery>;
export type OrgReportsLazyQueryHookResult = ReturnType<typeof useOrgReportsLazyQuery>;
export type OrgReportsSuspenseQueryHookResult = ReturnType<typeof useOrgReportsSuspenseQuery>;
export type OrgReportsQueryResult = Apollo.QueryResult<OrgReportsQuery, OrgReportsQueryVariables>;
export const OrgReportDocument = gql`
    query OrgReport($id: ID!) {
  orgReport(id: $id) {
    ...OrgReportFull
  }
}
    ${OrgReportFullFragmentDoc}`;

/**
 * __useOrgReportQuery__
 *
 * To run a query within a React component, call `useOrgReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrgReportQuery(baseOptions: Apollo.QueryHookOptions<OrgReportQuery, OrgReportQueryVariables> & ({ variables: OrgReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgReportQuery, OrgReportQueryVariables>(OrgReportDocument, options);
      }
export function useOrgReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgReportQuery, OrgReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgReportQuery, OrgReportQueryVariables>(OrgReportDocument, options);
        }
// @ts-ignore
export function useOrgReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgReportQuery, OrgReportQueryVariables>): Apollo.UseSuspenseQueryResult<OrgReportQuery, OrgReportQueryVariables>;
export function useOrgReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgReportQuery, OrgReportQueryVariables>): Apollo.UseSuspenseQueryResult<OrgReportQuery | undefined, OrgReportQueryVariables>;
export function useOrgReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgReportQuery, OrgReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgReportQuery, OrgReportQueryVariables>(OrgReportDocument, options);
        }
export type OrgReportQueryHookResult = ReturnType<typeof useOrgReportQuery>;
export type OrgReportLazyQueryHookResult = ReturnType<typeof useOrgReportLazyQuery>;
export type OrgReportSuspenseQueryHookResult = ReturnType<typeof useOrgReportSuspenseQuery>;
export type OrgReportQueryResult = Apollo.QueryResult<OrgReportQuery, OrgReportQueryVariables>;
export const GenerateOrgReportDocument = gql`
    mutation GenerateOrgReport($input: GenerateOrgReportInput!) {
  generateOrgReport(input: $input) {
    ...OrgReportListItem
  }
}
    ${OrgReportListItemFragmentDoc}`;
export type GenerateOrgReportMutationFn = Apollo.MutationFunction<GenerateOrgReportMutation, GenerateOrgReportMutationVariables>;

/**
 * __useGenerateOrgReportMutation__
 *
 * To run a mutation, you first call `useGenerateOrgReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrgReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrgReportMutation, { data, loading, error }] = useGenerateOrgReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOrgReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrgReportMutation, GenerateOrgReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrgReportMutation, GenerateOrgReportMutationVariables>(GenerateOrgReportDocument, options);
      }
export type GenerateOrgReportMutationHookResult = ReturnType<typeof useGenerateOrgReportMutation>;
export type GenerateOrgReportMutationResult = Apollo.MutationResult<GenerateOrgReportMutation>;
export type GenerateOrgReportMutationOptions = Apollo.BaseMutationOptions<GenerateOrgReportMutation, GenerateOrgReportMutationVariables>;
export const RegenerateOrgReportDocument = gql`
    mutation RegenerateOrgReport($reportId: ID!) {
  regenerateOrgReport(reportId: $reportId) {
    ...OrgReportListItem
  }
}
    ${OrgReportListItemFragmentDoc}`;
export type RegenerateOrgReportMutationFn = Apollo.MutationFunction<RegenerateOrgReportMutation, RegenerateOrgReportMutationVariables>;

/**
 * __useRegenerateOrgReportMutation__
 *
 * To run a mutation, you first call `useRegenerateOrgReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateOrgReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateOrgReportMutation, { data, loading, error }] = useRegenerateOrgReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useRegenerateOrgReportMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateOrgReportMutation, RegenerateOrgReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateOrgReportMutation, RegenerateOrgReportMutationVariables>(RegenerateOrgReportDocument, options);
      }
export type RegenerateOrgReportMutationHookResult = ReturnType<typeof useRegenerateOrgReportMutation>;
export type RegenerateOrgReportMutationResult = Apollo.MutationResult<RegenerateOrgReportMutation>;
export type RegenerateOrgReportMutationOptions = Apollo.BaseMutationOptions<RegenerateOrgReportMutation, RegenerateOrgReportMutationVariables>;
export const DeleteOrgReportDocument = gql`
    mutation DeleteOrgReport($reportId: ID!) {
  deleteOrgReport(reportId: $reportId) {
    _id
    status
  }
}
    `;
export type DeleteOrgReportMutationFn = Apollo.MutationFunction<DeleteOrgReportMutation, DeleteOrgReportMutationVariables>;

/**
 * __useDeleteOrgReportMutation__
 *
 * To run a mutation, you first call `useDeleteOrgReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgReportMutation, { data, loading, error }] = useDeleteOrgReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDeleteOrgReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrgReportMutation, DeleteOrgReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrgReportMutation, DeleteOrgReportMutationVariables>(DeleteOrgReportDocument, options);
      }
export type DeleteOrgReportMutationHookResult = ReturnType<typeof useDeleteOrgReportMutation>;
export type DeleteOrgReportMutationResult = Apollo.MutationResult<DeleteOrgReportMutation>;
export type DeleteOrgReportMutationOptions = Apollo.BaseMutationOptions<DeleteOrgReportMutation, DeleteOrgReportMutationVariables>;
export const OrganizationRosterDocument = gql`
    query OrganizationRoster($organizationId: ID!, $input: OrganizationRosterInput) {
  organizationRoster(organizationId: $organizationId, input: $input) {
    items {
      _id
      organizationId
      workEmail
      firstName
      lastName
      jobTitle
      department
      employeeStatus
      employeeId
      enrollmentStatus
      createdAt
      updatedAt
    }
    total
    hasMore
  }
}
    `;

/**
 * __useOrganizationRosterQuery__
 *
 * To run a query within a React component, call `useOrganizationRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRosterQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationRosterQuery(baseOptions: Apollo.QueryHookOptions<OrganizationRosterQuery, OrganizationRosterQueryVariables> & ({ variables: OrganizationRosterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationRosterQuery, OrganizationRosterQueryVariables>(OrganizationRosterDocument, options);
      }
export function useOrganizationRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationRosterQuery, OrganizationRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationRosterQuery, OrganizationRosterQueryVariables>(OrganizationRosterDocument, options);
        }
// @ts-ignore
export function useOrganizationRosterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationRosterQuery, OrganizationRosterQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationRosterQuery, OrganizationRosterQueryVariables>;
export function useOrganizationRosterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationRosterQuery, OrganizationRosterQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationRosterQuery | undefined, OrganizationRosterQueryVariables>;
export function useOrganizationRosterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationRosterQuery, OrganizationRosterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationRosterQuery, OrganizationRosterQueryVariables>(OrganizationRosterDocument, options);
        }
export type OrganizationRosterQueryHookResult = ReturnType<typeof useOrganizationRosterQuery>;
export type OrganizationRosterLazyQueryHookResult = ReturnType<typeof useOrganizationRosterLazyQuery>;
export type OrganizationRosterSuspenseQueryHookResult = ReturnType<typeof useOrganizationRosterSuspenseQuery>;
export type OrganizationRosterQueryResult = Apollo.QueryResult<OrganizationRosterQuery, OrganizationRosterQueryVariables>;
export const OrganizationRosterStatsDocument = gql`
    query OrganizationRosterStats($organizationId: ID!) {
  organizationRosterStats(organizationId: $organizationId) {
    totalEntries
    activeUsers
    pendingInvites
    notInvited
  }
}
    `;

/**
 * __useOrganizationRosterStatsQuery__
 *
 * To run a query within a React component, call `useOrganizationRosterStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRosterStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRosterStatsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationRosterStatsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables> & ({ variables: OrganizationRosterStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>(OrganizationRosterStatsDocument, options);
      }
export function useOrganizationRosterStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>(OrganizationRosterStatsDocument, options);
        }
// @ts-ignore
export function useOrganizationRosterStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>;
export function useOrganizationRosterStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationRosterStatsQuery | undefined, OrganizationRosterStatsQueryVariables>;
export function useOrganizationRosterStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>(OrganizationRosterStatsDocument, options);
        }
export type OrganizationRosterStatsQueryHookResult = ReturnType<typeof useOrganizationRosterStatsQuery>;
export type OrganizationRosterStatsLazyQueryHookResult = ReturnType<typeof useOrganizationRosterStatsLazyQuery>;
export type OrganizationRosterStatsSuspenseQueryHookResult = ReturnType<typeof useOrganizationRosterStatsSuspenseQuery>;
export type OrganizationRosterStatsQueryResult = Apollo.QueryResult<OrganizationRosterStatsQuery, OrganizationRosterStatsQueryVariables>;
export const BulkImportUsersDocument = gql`
    mutation BulkImportUsers($organizationId: ID!, $file: Upload!, $input: BulkImportUsersInput) {
  bulkImportUsers(organizationId: $organizationId, file: $file, input: $input) {
    successCount
    skippedCount
    errorCount
    errors {
      row
      error
    }
    warnings
  }
}
    `;
export type BulkImportUsersMutationFn = Apollo.MutationFunction<BulkImportUsersMutation, BulkImportUsersMutationVariables>;

/**
 * __useBulkImportUsersMutation__
 *
 * To run a mutation, you first call `useBulkImportUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkImportUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkImportUsersMutation, { data, loading, error }] = useBulkImportUsersMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      file: // value for 'file'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkImportUsersMutation(baseOptions?: Apollo.MutationHookOptions<BulkImportUsersMutation, BulkImportUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkImportUsersMutation, BulkImportUsersMutationVariables>(BulkImportUsersDocument, options);
      }
export type BulkImportUsersMutationHookResult = ReturnType<typeof useBulkImportUsersMutation>;
export type BulkImportUsersMutationResult = Apollo.MutationResult<BulkImportUsersMutation>;
export type BulkImportUsersMutationOptions = Apollo.BaseMutationOptions<BulkImportUsersMutation, BulkImportUsersMutationVariables>;
export const SendRosterInvitesDocument = gql`
    mutation SendRosterInvites($organizationId: ID!, $emails: [String!]!) {
  sendRosterInvites(organizationId: $organizationId, emails: $emails) {
    sent
    alreadyRegistered
    failed
  }
}
    `;
export type SendRosterInvitesMutationFn = Apollo.MutationFunction<SendRosterInvitesMutation, SendRosterInvitesMutationVariables>;

/**
 * __useSendRosterInvitesMutation__
 *
 * To run a mutation, you first call `useSendRosterInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRosterInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRosterInvitesMutation, { data, loading, error }] = useSendRosterInvitesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendRosterInvitesMutation(baseOptions?: Apollo.MutationHookOptions<SendRosterInvitesMutation, SendRosterInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRosterInvitesMutation, SendRosterInvitesMutationVariables>(SendRosterInvitesDocument, options);
      }
export type SendRosterInvitesMutationHookResult = ReturnType<typeof useSendRosterInvitesMutation>;
export type SendRosterInvitesMutationResult = Apollo.MutationResult<SendRosterInvitesMutation>;
export type SendRosterInvitesMutationOptions = Apollo.BaseMutationOptions<SendRosterInvitesMutation, SendRosterInvitesMutationVariables>;
export const OrganizationSsoDocument = gql`
    query OrganizationSSO($id: ID!) {
  organization(id: $id) {
    _id
    name
    sso {
      ...OrganizationSSOFields
    }
  }
}
    ${OrganizationSsoFieldsFragmentDoc}`;

/**
 * __useOrganizationSsoQuery__
 *
 * To run a query within a React component, call `useOrganizationSsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSsoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationSsoQuery(baseOptions: Apollo.QueryHookOptions<OrganizationSsoQuery, OrganizationSsoQueryVariables> & ({ variables: OrganizationSsoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSsoQuery, OrganizationSsoQueryVariables>(OrganizationSsoDocument, options);
      }
export function useOrganizationSsoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSsoQuery, OrganizationSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSsoQuery, OrganizationSsoQueryVariables>(OrganizationSsoDocument, options);
        }
// @ts-ignore
export function useOrganizationSsoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationSsoQuery, OrganizationSsoQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationSsoQuery, OrganizationSsoQueryVariables>;
export function useOrganizationSsoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationSsoQuery, OrganizationSsoQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationSsoQuery | undefined, OrganizationSsoQueryVariables>;
export function useOrganizationSsoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationSsoQuery, OrganizationSsoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationSsoQuery, OrganizationSsoQueryVariables>(OrganizationSsoDocument, options);
        }
export type OrganizationSsoQueryHookResult = ReturnType<typeof useOrganizationSsoQuery>;
export type OrganizationSsoLazyQueryHookResult = ReturnType<typeof useOrganizationSsoLazyQuery>;
export type OrganizationSsoSuspenseQueryHookResult = ReturnType<typeof useOrganizationSsoSuspenseQuery>;
export type OrganizationSsoQueryResult = Apollo.QueryResult<OrganizationSsoQuery, OrganizationSsoQueryVariables>;
export const UpdateOrganizationSsoDocument = gql`
    mutation UpdateOrganizationSSO($input: UpdateOrganizationSSOInput!) {
  updateOrganizationSSO(input: $input) {
    _id
    sso {
      ...OrganizationSSOFields
    }
  }
}
    ${OrganizationSsoFieldsFragmentDoc}`;
export type UpdateOrganizationSsoMutationFn = Apollo.MutationFunction<UpdateOrganizationSsoMutation, UpdateOrganizationSsoMutationVariables>;

/**
 * __useUpdateOrganizationSsoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSsoMutation, { data, loading, error }] = useUpdateOrganizationSsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSsoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSsoMutation, UpdateOrganizationSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSsoMutation, UpdateOrganizationSsoMutationVariables>(UpdateOrganizationSsoDocument, options);
      }
export type UpdateOrganizationSsoMutationHookResult = ReturnType<typeof useUpdateOrganizationSsoMutation>;
export type UpdateOrganizationSsoMutationResult = Apollo.MutationResult<UpdateOrganizationSsoMutation>;
export type UpdateOrganizationSsoMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSsoMutation, UpdateOrganizationSsoMutationVariables>;